    const reviewData = [
        {
            name: "Ali İ.",
            title: "Harika Bir Yatak",
            comment: "1 yıl kadar önce 2 yaşındaki kızım için yatak almak istedik. Araştırmalarımız sonucunda bu yatağı bulduk. Ozonla temizleme imkanı olduğu için bu yatağı seçtik, şimdi kızım başka yatakta uyumak istemiyor. Yine olsa bu yatağı satın alırdık.",
            product: "Future Air Clean",
            star: 5,
            image: false,
            video: "https://cdn.shopify.com/videos/c/o/v/a91dc32fbe02462e8b2a6c848138a386.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/ALI_I._IZMIR_OK.mp4_snapshot_00.01.804_0d6225fe-ac16-471a-969f-e4a53f463d59.jpg?v=1724053983"
        },
        {
            name: "Abdullah S.",
            title: "Ağrısız Uyanmak",
            comment:  "Hep ağrılarla uyanıyordum tavsiye üzerine denedim ve artık uykularım bölünmüyor.Teşekkürler.",
            product: "Logic Air Clean",
            star: 5, // *4 *3 *2 *1
            image: true, // *false
            video: "",
            poster: ""
        },
        {
            name: "Ahmet A.",
            title: "Kalitesi Çok İyi",
            comment:  "Tekstilci olduğum için ilk baktığım yeri kumaşı oldu. Almadan önce çok mağaza gezmiştim ve bundan daha iyi dokusu olan bir yatağa rastlamadım. Yatak konfor olarak beklentimi karşıladı. Başarılar.",
            product: "Logic Air Clean",
            star: 5, // *4 *3 *2 *1
            image: false,
            video: "",
            poster: ""
        },
        {
            name: "E. Yurtsever",
            title: "Harika Bir Ürün",
            comment: "MERHABALAR, ÖNCE KOMŞUMUZ ALDI MENNUN KALINCA BİZE DE TAVSİYE ETTİ. ÇOK MEMNUNUZ 3 AYDA BİR YATAK TEMİZLENMESİ ÇOK İLGİNÇ. BİR HAFTADA EŞİMİN BEL AĞRISI GEÇTİ. İNANAMADIK. ŞİDDETLE HERKESE BİZDE TAVSİYE EDİYORUZ.",
            product: "Logic Air Clean",
            star: 5,
            image: false,
            video: "https://cdn.shopify.com/videos/c/o/v/5270412a02074ec481b8c2f81dd493d4.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/E.YURTSEVER_ISTANBUL.mp4_snapshot_00.09.905.jpg?v=1724054832"
        },
        {
            name: "Ahmet K.",
            title: "Pahalı :(",
            comment:  "Evet ürün çok iyi biz alerjik durumdan ötürü almak zorunda hissettik. Şu an kadar ki deneyimimiz oldukça iyi ama fiyatı daha uygun olsa daha fazla insana ulaşabilir.",
            product: "Code Air Clean",
            star: 5, // *4 *3 *2 *1
            image: false,
            video: "",
            poster: ""
        },

        {
            name: "Ali Can Y.",
            title: "Çok Rahat",
            comment:  "Yatak resimdeki ile aynı, gayet güzel ve rahat. Teslimat ve paketleme de süperdi. Kesintisiz uyuyorum, cok memnunum.",
            product: "Logic Air Clean",
            star: 5, // *4 *3 *2 *1
            image: true,
            video: "",
            poster: ""
        },
        {
        name: "Arda Ç.",
        title: "1 Yıldır Memnuniyetle Kullanıyoruz",
        comment: "MERHABA, BUGÜN 1 YILDIR KULLANMAKTA OLDUĞUM SLOTH BEDDING ÜRÜNÜNDEN BAHSETMEK İSTİYORUM. OLDUKÇA MEMNUNUZ, HİÇBİR OLUMSUZ DURUMLA KARŞILAŞMADIK. MÜŞTERİ HİZMETLERİ ÇOK İLGİLİ. YATAK TEMİZLENEBİLİYOR. TAVSİYE EDERİZ.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/527d7e1450674f04ab9cb105794b48fa.mp4",
        poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/ARDA_C._ANKARA_.mp4_snapshot_00.06.198.jpg?v=1724054859"
        },
        {
            name : "Ali Ş.",
            title : "Kaliteli Uyku",
            comment : "Yoğun ve masabası çalışıyorum sadece uyurken dinlenebiliyorum ve artık çok daha zinde uyanıyorum. Teşekkürler.",
            product : "Reboot Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Alper K.",
            title : "Annem İçin",
            comment : "Annem temizlik hastası ve boyun fıtığı var. Sloth Beddingle  karşılaşınca kısa bir araştırma sonrası aldım. Annem çok memnun her gün bana dua ediyor. Teşekkürler Sloth Bedding.",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Asuman Huriye T.",
        title: "Gebelik ve Sonrası İçin Mükemmel Seçim",
        comment: "Gebeliğimin son 4 ayında rahat uyuyabilmek için ve bebeğim doğduktan sonra uykumun her anı değerli olduğu için Sloth Bedding’i seçtik. Gebelik döneminde hiç belim ağrımadı, yatağın dokusu mükemmel ayrıca yastıklarımızdan da çok memnunuz.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/c7adfdf57ea84877a13bbf306a8f8d89.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/ASUMAN_HURIYE_T._KONYA_OK.mp4_snapshot_00.24.329.jpg?v=1724055027"
        },
        {
            name : "Aslı U.",
            title : "Bebeğim İçin",
            comment : "Özenilerek üretilmiş, kalitesi muhteşem. Geceleri çok terleyen oğlum için özellikle tencel kumaşı olduğundan seçtim.",
            product : "Future Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Aslıhan D.",
            title : "İnanılmaz Rahat",
            comment : "İnanılmaz rahat bir yastık... Tüm boyun ağrılarım geçti artık başka bir yastık kullanamıyorum, tatillere bile yanımda götürüyorum. Teşekkürler.",
            product : "Slothy Latex Ortopedik Yastık",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Aybars Furkan Ş.",
        title: "Konfor ve Teknolojiyi Bir Arada Bulduk",
        comment: "Kızımız Tomris 1 yaşındayken yatak araştırmasına başladık. Bütün markaları inceledik ve tercihimizi Sloth Bedding’den yana kullandık. Konforlu, rahat ve Air Clean teknolojisi bizi cezbetti. 6 aydır kullanıyoruz, çok memnunuz.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/bcbf122bbdaf46faaeb854df7caa2fab.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/AYBARS_FURKAN_S._ISTANBUL_OK.mp4_snapshot_00.19.000.jpg?v=1724055031"
        },
        {
            name : "Aycan Ç.",
            title : "Kesinlikle Tavsiyemdir",
            comment : "Bu yatağı baya araştırdıktan sonra aldık inanılmaz güzel gerçekler çok içime sinen bir ürün bebeğimiz için rahat uyusun hijyenik olsun detayları bizim için çok önemliydi bu yüzden teşekkür ederiz.",
            product : "Future Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Aysel S.",
            title : "Harika Görsel",
            comment : "Ürünlerin çantalarına bayıldım. Tek kullanımlık değil ve tasarımı harika. Tabiki yastık da çok rahat ama daha ürünü elinize aldığınızda paketlemeden bile etkileniyorsunuz.",
            product : "Slothy Latex Ortopedik Yastık",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Aygül M.",
        title: "Aile Boyu Memnuniyet",
        comment: "MERHABA, AİLECEK SLOTH BEDDING KULLANIYORUZ. ÇOK MEMNUNUZ, TAVSİYE EDERİZ.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/82ce072cd38f4f1eb1cc2a14189fc039.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/Aygul_M.png?v=1724058610"
        },
        {
            name : "Ayşe A.",
            title : "Göründüğünden Fazlası",
            comment : "Ürünü almadan burada çok yorum okudum ayrıca marka internet sitesinden paketlemesine kadar çok kaliteli olduğunu belli ediyordu. Ve gerçekten göründüğünden çok daha fazlasına sahip oluyorsunuz.",
            product : "Reboot Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
            name : "Ayşe K.",
            title : "Boyun Ağrısı",
            comment : "Müthiş bir yastık, ağrılarım yok denecek kadar azaldı. Tavsiye ederim.",
            product : "Slothy Visco Ortopedik Yastık",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Ayla Ö.",
        title: "Anne ve Bebek İçin Mükemmel Seçim",
        comment: "Bebeğim için aldım, en rahat uykusunu uyuyor. Eminim ki anne ve bebek sağlığını düşünen tek firma. Bütün ürünler probiyotik olarak tasarlanmış. İyi ki var ve iyi ki almışım, mutlaka alın.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/4725c038d2d34ecea6b0dcf041865c91.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/AYLA_O._AYDIN_OK.mp4_snapshot_00.21.251.jpg?v=1724055063"
        },
        {
            name : "Ayşegül D.",
            title : "Konforlu ve Temiz",
            comment : "Çok memnun kaldım. Tavsiye ederim.",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Ayşen N.",
            title : "Bebek Yatağı",
            comment : "Hem hava alabilen hem de kendini temizleyebilen bir ürün. Bebekler için çok konforlu. Test edip onaylama şansım oldu. Kesinlikle tavsiye ediyorum.",
            product : "Future Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Ayşegül D.",
        title: "Yatak Temizliği ve Sağlık",
        comment: "KIZIMIN ODASINI DEĞİŞTİRİRKEN TANISHAK SLOTH BEDDING İLE, ÇOK YATAK ARAŞTIRMASI YAPMIŞTIK. YATAĞIN TEMİZLENEBİLİYOR OLMASI BENİ ÇEKTİ. BEN HEMŞİREYİM, KIZIMIN ATAKLARI AZALDI. KESİNLİKLE TAVSİYE EDERİZ.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/60c3403f6c814b62a5587f74928fa24a.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/AYSEGUL_D._IZMIR_.mp4_snapshot_00.02.768.jpg?v=1724055145"
        },
        {
            name : "Başak A.",
            title : "Çok Sevdik",
            comment : "Eşim gece çok fazla hareket ediyor. Önce ki yatağımız eşim döndükce sallanıyordu. Yeni yatağımızda bu problem ortadan kalktı. Ayrıca temizleme özelliği muhteşem.",
            product : "Connect Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Betül D.",
            title : "Alerjisi Olanlar İçin Harika",
            comment : "Kılıfı çıkıp yıkanabiliyor ve kendini temizliyor olması harika! Eşimle astım hastayız ve en çok tetikleyen maytlardan bu yatak sayesinde kurtulduk. Hapşurmadan ve gözümüz akmadan uyuyoruz.",
            product : "Reboot Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Ayşen N.",
        title: "Uzun Süreli Kullanım Sonrası Deneyim",
        comment: "Merhabalar herkese, ben 1 yıl bekledim bu videoyu çekmek için. Acaba gerçekten memnun olur muyum ya da bir sorunum olur mu diye? Yatağın kendini temizleme özelliği var ve ortopedik bir yatak. Hiçbir şekilde bel ağrısı yapmıyor. Ben yastıkları da kullanıyorum. Gayet memnunum, boyun ağrımdan kurtuldum. Tavsiye ediyorum.",
        product: "Logic Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/325efe65059a4853a11211a491e678e2.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/AYSEN_N._ISTANBUL_OK.mp4_snapshot_00.03.939.jpg?v=1724055151"
        },
        {
            name : "Can E.",
            title : "Oldukça İyi",
            comment : "Eşimle aramızda çok kilo farkımız var. Müşteri hizmetleri bunun için yatış pozisyonumuza kadar sordu ve Logic yatağı önerdi.Boşa geçen yıllıramıza yanıyorum :)",
            product : "Logic Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },

        {
            name : "Caner Ü.",
            title : "Gerçekten Çok Rahat",
            comment : "İlk visco modeli satin almistim,ancak aliskanliktan oturu bana sert geldi.Latex modeli ile degisim sagladim ve bu yatagin rahatliğindan cok memnunum.Herkese tavsiye edebilirim.",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Begüm T.",
        title: "İkizler İçin Mükemmel Seçim",
        comment: "Merhabalar, ikizlerimiz olunca Sloth Bedding'den iki ayrı yatak aldık. Çok rahatlar ve sonrasında kendimiz için de aldık. İkizlerimiz mutlu, biz de mutlu.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/ba36f8dc0c5a41979c99f404659d46e3.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/BEGUM_T._ISTANBUL_OK.mp4_snapshot_00.00.000.jpg?v=1724055160"
        },
        {
            name : "Cuma K.",
            title : "Beklediğimden Çok Çok İyi",
            comment : "Alma konusunda tereddütlüydüm. İnternetten bu tutarda bir alışveriş daha önce yapmamıştım. Ancak paramın hakkını sonuna kadar alıyorum bu işi bilerek yaptıkları çok belli.",
            product : "Reboot Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Cüneyd K.",
            title : "Klimalı Gibi",
            comment : "Bodrumda yaşadığım için terleme sorunu yaşatmayacak bir yatak arayışım vardı. Çok ilgili yaklaştılar ve bu ürünü özellikle tavsiye ettiler. Klimalı gibi çok rahat kullanıyorum.",
            product : "Logic Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
        name: "Burak O.",
        title: "1,5 Yıldır Memnuniyet",
        comment: "Merhabalar, 1,5 yıldır Sloth Bedding'den bu yatağı kullanıyoruz. Alez de aldık, yastık da aynı yerden. Zaten çok rahat bir yatak, çok memnunuz.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/2e2959c461a340658b4bc9acc78c9b33.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/BURAK_O.KOCAELI.mp4_snapshot_00.01.940.jpg?v=1724055165"
        },
        {
            name : "Deniz Ö.",
            title : "Çocuklarım İçin Tam İsabet",
            comment : "Yeni evimize taşınırken internette gördüm. Temizlik özelliği çok ilgimi çekti. İyiki almışım. Hem çocuklarım çok rahat hemde içim :)",
            product : "Reboot Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
            name : "Derya B.",
            title : "Çabuk Alıştık",
            comment : "İlk hafta alışmakta zorlandık müşteri hizmetleri sadece 1 ay deneyin memnun kalmazsanız hemen alırız dediler ve gerçekten 2. haftadan sonra ağrımız olmadan uyanmaya başladık. Dünya ilk dedikleri temizle teknolojileri ilgici çekici.",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Burcu K.",
        title: "Kızım İçin Harika Bir Seçim",
        comment: "Merhaba, ben Burcu Kılınç. Kızım için bir yatak arayışı içindeydim. Ekim ayında Sloth Bedding'den bu yatağı tercih ettik ve çok severek kullanıyoruz. Herkes tavsiye ederiz.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/ac91042eae884f7b8de629554f6ebf84.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/BURCU_K._ISTANBUL_OK.mp4_snapshot_00.03.189.jpg?v=1724055169"
        },
        {
            name : "Derya E.",
            title : "Gerçekten Mükemmel",
            comment : "İyi ki almışım aldığım günden beri uykularım bölünmüyor hayat kalitem arttı diyebilirim ayrıca mükemmel bir yay sistemi var, bir tarafta zıplasanız bile diğer taraftaki kişi sallanmadan uyuyabiliyor.",
            product : "Reboot Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Doğu Y.",
            title : "Mükemmel",
            comment : "Kızım her gece yanımıza geliyor uyumaya, yeni yatağı aldığıma sevinmek için bir sebep daha oldu.",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Burcu K.",
        title: "Terleme ve Temizlikte Mükemmel Seçim",
        comment: "EVEEET, TERLEYEN BİR EŞİNİZ VARSA VE ÇİŞ EĞİTİMİ VERDİĞİNİZ BİR ÇOCUĞUNUZ VARSA, BEN BU YATAĞI ALALI BİR YIL OLDU, ÇOK MEMNUNUM. 3 AYDA BİR TEMİZLİK YAPIYORUZ. ODAYI DA TEMİZLİYOR, YATAK YENİ KALIYOR. BÜTÜN SIKINTILARIMIZ BİTTİ. GERÇEKTEN TAVSİYE EDİYORUZ. BAŞKA YERDE YATTIGIMDA BELİM AĞRIYOR. EVE GELİP YATTIGIMDA AĞRIM GEÇİYOR. İYİ Kİ ALMIŞIM. KENDİNİZ ALMAYIN, UZMANLARLA KONUŞUN, ÇOK YARDIMCI OLuyorLAR.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/8400d6690ab441438eefd85e32b5595f.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/BUIRCU_K.ISTANBUL.mp4_snapshot_01.34.639.jpg?v=1724055188"
        },
        {
            name : "Duygu B.",
            title : "Visco Yastık",
            comment : "2 yastık aldım ve daha önce sahip olduğum yastıklarla arasında büyük bir fark olduğunu söyleyebilirim. Fiyat olarak baya yukarda ama sebebini kullanınca anlıyorsunuz. ",
            product : "Slothy Visco Ortopedik Yastık",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Egemen Y.",
            title : "Farklı ve Etkileyici",
            comment : "Yatağın rahat ve ergonomik yapısı dışında odada mevcut oksijeni ozon gazına çeviren air cleaner ile temizlenebiliyor olması benim için ürünün en ilgi çekici ve de etkileyici özelliği.",
            product : "Reboot Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
        name: "Büşra E.",
        title: "Hayran Kaldık",
        comment: "Sloth Bedding yatak aldık ve temizliğine hayran olduk. Dünyada tek olan güzel bir sistem olmuş.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/e9d6bf0f57e946ae8c27030a64347296.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/BUSRA_E._ISTANBUL_OK.mp4_snapshot_00.00.791.jpg?v=1724055354"
        },
        {
            name : "Elif Ö.",
            title : "Harika Seçim",
            comment : "Oğlumuz biraz alerjik olduğu için tavsiye üzerine aldık. Sonuç harika. Çok teşekkürler.",
            product : "Reboot Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
            name : "Elif S.",
            title : "Uyku Kalitesi",
            comment : "Bu yatakta uyuduktan sonra kaç saat uyuduğunuzun bir önemi yok! Her türlü dinç uyanıyorsunuz.. resmen kaliteli uykunun önemini slothbedding sayesinde yaşadım ",
            product : "Connect Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Ceren Varen A.",
        title: "Temizlikte Mükemmel Performans",
        comment: "Bugün temizlik günümüz, Sloth Bedding yatağımızı ozonla tertemiz yaptık. Dünyanın en rahat yatağı, çok memnunuz.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/0f0307d26ab346aa86c2f33e4aada2e3.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/CEREN_VAREN_A.ORDU_.mp4_snapshot_00.23.003.jpg?v=1724055400"
        },
        {
            name : "Emrah K.",
            title : "Süper Rahat",
            comment : "Doğal olması muhteşem ayrıca yatakla beraber gelen cihaz çok etkileyici gece uyku düzenimiz düzeldi.",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Emre V.",
            title : "Muhteşem Bir Yastık",
            comment : "Yastığı 2.5 aydır kullanıyorum. Gerçekten çok rahat bir yastık. 1 kere alıştıktan sonra başka yastıklarda yatmak istemeyeceksiniz. Ayrıca birlikte gelen çantası da gerçekten çok hoş.",
            product : "Slothy Visco Ortopedik Yastık",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Deniz A.",
        title: "Astım Hastası İçin Harika Seçim",
        comment: "Oğlumun yatağını Sloth Bedding'den tercih ettim. Bu şekilde bir cihaz var yanında, bu cihaz alerjen durumları ve tozlardan arınmayı sağlıyor. Astım hastası olan oğlum çok rahat, ben çok memnunum ve çok ilgileniyorlar. Tavsiye ediyorum.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/06a6b26f9b84406c91322df6db33ab93.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/DENIZ_A._ISTANBUL_OK.mp4_snapshot_00.09.942.jpg?v=1724055409"
        },
        {
            name : "Erdem B.",
            title : "Sertliği Mükemmel",
            comment : "Yatak kesinlikle mükemmel. Sertlik derecesi ne sert ne yumuşak ben 95 kiloyum bana çok iyi geldi.",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Esra U.",
            title : "Yastığıma Aşığım :)",
            comment : "Eşimle seyahat etmeyi çok seviyoruz. Otellerde uyumak tam bir kabustu benim için şimdi muhteşem çantasına koyup her yere götürüyorum.",
            product : "Slothy Visco Ortopedik Yastık",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Dilara A.",
        title: "5 Ayda Büyük Memnuniyet",
        comment: "Sloth Bedding çocuk yatağı olan Future'ı aldık. Ben alalı 5 ay oldu, kullanımımdan çok memnunuz. Hem pediatrik hem de bize özel yapılması çok güzel. İki kere yatak temizliği yaptım, kendi cihazı var. İçimiz rahat.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/454aa4d616e1416093756ade51bba46c.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/DILARA_A._ANTALYA_OK.mp4_snapshot_00.25.084.jpg?v=1724055414"
        },
        {
            name : "Evren T.",
            title : "Muhteşem",
            comment : "Gayet rahat, konforlu ve kaliteli bir yatak, gönül rahatlığıyla sipariş verebilirsiniz. Herkese tavsiye ederim.",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Eyüp Y.",
            title : "Umduğumdan Çok Daha İyi Çıktı",
            comment : "Ürün bu sabah geldi. Kurulumu çok basitmiş. Açıkçası umduğumuzda çok daha iyi bir yatak. Yatağın yanında verdikleri cihaz enaz yatak kadar şık. Sonunda aksırmadan tıksırmadan uyuyacağım.",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Dilay H.",
        title: "Ev Alışverişinde En Güzel Karar",
        comment: "Merhaba, size ev alışverişinde yaptığım en güzel şeyi anlatmak istiyorum. Tek kelimeyle muhteşem! Ben ve eşim sürekli ayakta çalışıyoruz, benim bel fıtığım var ve sürekli ağrım vardı. Bu yatak sayesinde rahat uyuyoruz. Çok ilgililer, sorularınıza en doğru cevapları veriyorlar. Herkesin bir şans vermesini tavsiye ederim.",
        product: "Reboot Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/cd7eb7a7cfc3485c8be95c83a121998a.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/DILAY_H._ISTANBUL_OK.mp4_snapshot_00.29.040.jpg?v=1724055419"
        },
        {
            name : "Fani İ.",
            title : "Uyku Sorunumuz Çözüldü",
            comment : "3.5 yaşındaki kızım geceleri çok terliyordu. Yatağın bence hava sirkülasyonu gayet iyi çünkü bizim terleme problememiz çözüldü. Ayrıca birkaç kez kızım çiş yaptı kılıfını yıkadık ve içini ozonla temizledik. Bir anne olarak içim çok rahat.",
            product : "Future Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Fırat A.",
            title : "Serin Uyku",
            comment : "Serinlik hissi veren yastık iddasını merak ettiğim için aldım. Çok memnun kaldım. tavsiye ederim.",
            product : "Slothy Cool Outlast Yastık",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Ebru Y.",
        title: "Reboot Yatakla Büyük Rahatlama",
        comment: "Merhaba, yatağım 180x200 Reboot olanını tercih ettim. Yan taraflarda bulunan temizleme kanalları var. Yastığı da aldım, visko olanı aldım. Boyun ağrılarım geçti. Oğluma da aldım, çok memnunum. Kesinlikle alın, teşekkür ederim.",
        product: "Reboot Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/71b344d92c6548b8ae07fefee03c135e.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/EBRU_Y._ZONGULDAK.mp4_snapshot_00.03.623.jpg?v=1724055762"
        },
        {
            name : "Fırat B.",
            title : "Umarım Yatağı da Alabilirim",
            comment : "Yastığını aldım,az kaldı yatağını da alacağım biraz daha çalışmam gerek galiba.",
            product : "Slothy Latex Ortopedik Yastık",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Filiz B.",
            title : "Süper",
            comment : "Eşim ve ben sürekli oturarak çalışıyoruz. İkimizinde bel problemleri var. 100 gün deneme süresine güvenerek aldık. İyi ki şans vermişiz evlendiğimizden beri yaptığımız en iyi işlerden.",
            product : "Code Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
        name: "Ecem Varlı A.",
        title: "Lösemi Hastası İçin Güvenli ve Rahat Seçim",
        comment: "Herkese merhabalar, biz Sloth Bedding’i özel bir durumdan dolayı tercih ettik. Verdiğimiz en iyi karardı. Oğlum lösemi hastası ve enfeksiyon kapmaması gerekiyor. Temizlenebilen bir yatak olması çok güzel ve oğlum o kadar rahat uyuyor ki anlatamayız. Yastıklarını da kullanıyoruz. Öyle güzel, öyle rahat ki kesinlikle deneyin.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/39379dc53bd84e99894ccab26c316897.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/ECEM_VARLI_A._ISTANBUL_OK.mp4_snapshot_00.20.015.jpg?v=1724055767"
        },  
        {
            name : "Fulya A.",
            title : "Değişime İnanın",
            comment : "Bel ve boyun ağrılarımın giderilmesinde yatak ve yastığın bu kadar önemli olduğunu yeni yatağımla öğrendim.",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Furkan B.",
            title : "İkimiz de Çok Mutluyuz",
            comment : "Eşimin hijyen çılgınlığını bu yatakla çözdüğüne mi sevineyim birde yatağın gerçekten bana da çok iyi geldiğine mi..",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Eda Kaya K.",
        title: "Alerjik Kızım İçin İdeal Seçim",
        comment: "Merhaba, ben Sloth Bedding'den 2 yaşındaki alerjik kızım için bir yatak siparişi vermiştim. 90x190 ölçüsünde yaptırdık. Kızıma çok iyi geldi, cihazı var ve 3 ayda bir kere temizlik yapıyoruz. Çok memnunuz.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/0980e0539d504552919d7f14872f3ace.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/EDA_KAYA_K._SANLIURFA_OK.mp4_snapshot_00.23.680.jpg?v=1724055772"
        },
        {
            name : "Gamze A.",
            title : "Zamanında ve Sorunsuz ",
            comment : "Yatak siparişten sonra 1 hafta içinde elime ulaştı. Horoz kargo kapıma kadar çıkardı. Paketleme çok iyiydi. Yataktan çok memnunuz. ",
            product : "Reboot Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Gamze D.",
            title : "Süperrrr",
            comment : "Eski yatağımızın üst kılıfı o kadar toz tutuyordu ki süpürüp silsem de içim rahat etmiyordu. Çıkarıp yıkayabiliyor olmak işimi çok kolaylaştırdı. Ayrıca temizleme teknolojisi süperrrr.",
            product : "Connect Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Efkan A.",
        title: "Yaşam Kalitesinde Artış",
        comment: "Sloth Bedding yatağımızı severek kullanıyoruz. İyi ve sağlıklı bir uyku uyuyoruz, yaşam kalitemiz yükseldi.",
        product: "Reboot Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/6bb0ed27d37c49bfbbdb4012f3112516.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/EFKAN_A._AYDIN_.mp4_snapshot_00.02.290.jpg?v=1724055776"
        },
        {
            name : "Görkem Ö.",
            title : "Dinlenmiş Uyanıyorum",
            comment : "Gece mutlaka birkaç kez uyanırdım ve uykum bölünürdü. Artık gece uykumlarım kesintisiz hale geldi ve sabahları dinlenmiş uyanıyorum. Teşekkürler",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },

        {
            name : "Gülben A.",
            title : "Alerjik",
            comment : "Temizlik benim için önemli olduğu için sloth bedding i tercih ettim. Temizliği çok kolay, artık içimiz rahat bir şekilde uyuyoruz. Ayrıca o kadar rahat ki sırt ağrılarımı hemen azalttı.",
            product : "Connect Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Elif Güler A.",
        title: "Kaliteli Uyku İçin Tercih",
        comment: "Merhaba öncelikle. Biz kızımız için yatak arayışındaydık, bu firmayla tanıştım. Kaliteli bir uyku uyumak isterseniz kesinlikle alın. Sloth Bedding ailesine ilgilerinden dolayı teşekkür ediyorum.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/3c1a605e23cc4eb78d710f68d93fab91.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/ELIF_GULER_A._ORDU.mp4_snapshot_00.02.213.jpg?v=1724055781"
        },
        {
            name : "Gürkan G.",
            title : "En İyi Uykum",
            comment : "Ben oldukça eleştirmeyi severim ve beni etkilemek zor ve şaşırtıcıdır :) İlginç bir şekilde sıfır şikayetim var.",
            product : "Connect Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Hakan C.",
            title : "Güzel",
            comment : "Güzel ürün",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Elif U.",
        title: "Sağlık Problemleri İçin İdeal Çözüm",
        comment: "Merhabalar, 2022 yılında yeni bir yatak arayışına girdik. Benim boyun düzleşmem ve eşimin alerjik olması sebebiyle titiz davrandık. Bizim sağlık problemlerimizi öğrendiler ve çok iyi yönlendirdiler. Bize Code serisini tavsiye ettiler. Eşimin nefes alışları düzeldi, ben çok rahatım, biz çok memnunuz.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/a3429d739c0047819cc3958e9c8464c8.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/ELIF_U._ISTANBUL_OK.mp4_snapshot_00.02.401.jpg?v=1724055786"
        },
        {
            name : "Hande G.",
            title : "Çok Fark Etti",
            comment : "Yastığın bu kadar fark yaratabileceğini düşünmemiştim. Yatağımıda değiştireceğim ilk fırsatta.",
            product : "Slothy Latex Ortopedik Yastık",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Hande K.",
            title : "Pamuk Ped",
            comment : "Çocuğumun yatağında su geçirmez alez kullanmak istemiyordum çünkü terletme yapıyor. Araştırmalarım sonucu doğal pamuklu bu pedi aldık ve aşırı iyi çıktı. Kılıf denilmiş ama ped olacak kadar kalın bir malzeme tavsiye ederim.",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Fatih A.",
        title: "5 Aydır İnanılmaz Memnuniyet",
        comment: "Sloth Bedding Air Code Clean modeliyle 5 ay önce tanıştık. 5 aydır inanılmaz memnunuz. Yanında temizlik cihazı veriyorlar. Bize özel üretim yapıldı. Gerçekten Sloth Bedding bu işte çok çok iyi.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/47a31ac34aee4823ba2c5c00a6cce7b6.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/FATIH_A._ISTANBUL_OK.mp4_snapshot_00.00.000.jpg?v=1724055918"
        },
        {
            name : "Hülya D.",
            title : "Kolay İletişim",
            comment : "Merak edip aradığımda karşımda birebir yetkili birisi ile görüşmek harikaydı. Üründen çok memnun kaldım.",
            product : "Slothy Visco Ortopedik Yastık",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Hülya T.",
            title : "Doktor Önerisi",
            comment : "Yoğun olarak çalışıyorum ve gece uykularıma oldukca önem veriyorum. Ayrıca hastalarım da sürekli benden tavsiye istiyorlar yatak konusunda ve memnun kaldığım için hastalarımı da gönül rahatlığıyla öneriyorum. Teknolojisini ve konforunu çok beğendim başarılar çocuklar .",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Fatma Ö.",
        title: "Oğlum İçin Mükemmel Seçim",
        comment: "Merhaba, Sloth Bedding oğlum için tek kişilik yatağını kullanıyorum. Çok memnunum, bir de yastığını almıştım. Terletme yapmıyor. Yatak temizleme yapılıyor. Üst yüzey çok güzel.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/56201ea1b32e49f3b3e10a52bf6f43e0.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/FATMA_O._CANAKKALE_OK.mp4_snapshot_00.30.943.jpg?v=1724055920"
        },
        {
            name : "Hüseyin B.",
            title : "Muhteşem",
            comment : "Gönül rahatligiyla tavsiye ederim. Muhteşem bir ürün. Kronik alerji rahatsizliginiz varsa hiç düşünmeden alin derim. Teşekkürler Slothbedding",
            product : "Reboot Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "İhsan K.",
            title : "Uykuların en güzeli",
            comment : "Yatak teknolojiniz sayesinde artık uykularım daha uzun ve keyifli, Emeği olan herkese teşekkür ederim.",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Fatmanur G.",
        title: "Kızımız İçin Mükemmel Yatak",
        comment: "Kızımız için Future Air Clean yatak kullanıyoruz. Yaklaşık 9 aydır Sloth Bedding'i, iyi ki bulmuşuz. Biz kendimiz de almayı düşünüyoruz. Çok rahat, vücudun şeklini alan, bebeklerin gelişimi için güzel bir yatak. Teşekkürler Sloth Bedding.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/3161511191ee495984027ca5484a5354.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/FATMANUR_G._SAMSUN_OK.mp4_snapshot_00.03.343.jpg?v=1724055927"
        },
        {
            name : "Kubilay O.",
            title : "Süper Teknoloji",
            comment : "3 ay kadar önce aldığımız latex serisi yataktan çok memnunuz. Hiç bir yatakta bu denli rahat etmemiştik. Herkese tavsiye ederiz. Ayrıca ozon sistemi ile temizlenebilmesi süper.",
            product : "Code Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
            name : "Kurtuluş M.",
            title : "Dosta Gider :)",
            comment : "Bu yatak dosta gider dedikleri cinsten :) 4.haftamızdayız ve aşırı mutluyuz. Yanında gelen cihaz ile evimizin havasını da temziliyoruz. Sağolun",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Fırat G.",
        title: "Bel Ağrısından Kurtulduk",
        comment: "Merhaba, ben Sloth Bedding ile 1 yıl önce tanıştım. Önceki yatağımızda bel ağrımız oluyordu. Şu anda bel ağrımız yok, severek kullanıyoruz. Ayrıca müşteri ilişkileri çok iyi, çok yardımcı oluyorlar.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/f4411bcc5c0641a3ac4dc46370657239.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/FIRAT_G.ISTANBUL.mp4_snapshot_00.02.484.jpg?v=1724055931"
        },
        {
            name : "Mehmet S.",
            title : "Güzel İcat",
            comment : "Patentli ve dünyada ilk defa olduğunu duyunca ilgili çekti. Çok güzel bir teknoloji. Yerli olması ayrıca çok hoşuma gitti. Başarılar.",
            product : "Connect Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Melek Ç.",
            title : "Sonunda Buldum",
            comment : "Yıllardır yastık arayışım vardı bir türlü aradığım yastığı bulamıyordum. Müşteri hizmetleri lateks kullanmamı önerdi çok memnunum. Ayrıca yastık çantası muhteşem ötesi.",
            product : "Slothy Latex Ortopedik Yastık",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Firdevs Feyza I.",
        title: "Bel Ağrısını Unuttuk",
        comment: "Ben Sloth Bedding yatağını 2 yıl önce aldım. Tavsiye üzerine aldım. Sabah uyandığımda belim ağrımıyor. Harika paketleme yapılmıştı. Bu ürünü yapanlara teşekkür ediyorum.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/678ec56579e04dbfb959d90740aad4c3.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/FIRDEVS_FEYZA_I._ISTANBUL.mp4_snapshot_00.02.435.jpg?v=1724055936"
        },
        {
            name : "Mine P.",
            title : "Annemden Kızıma :)",
            comment : "Ben işim dolayısı ile çok seyahat ettiğimden kızım sık sık annemlerde kalıyor ve alerjik bir çocuğum var. Ayrıca annemde çok titiz yatağı görür görmez  almak istedi kızım da annem de çok mutlular.",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Murat A.",
            title : "Güzel Ürün",
            comment : "Tavsiye üzerine kızım için aldım. Memnun kaldım. tavsiye ederim.",
            product : "Reboot Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
        name: "Gürkan Ali",
        title: "Özel Yapılmış Yatak ile Memnuniyet",
        comment: "Oğlumun yatağı özel yapıldı. Ben de çocuğumla birlikte yatıyorum, memnunum. Tavsiye ederiz.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/e3456950cc3e40478df2a405b266ffb2.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/GURKAN_ALI_.CATALCA.mp4_snapshot_00.01.751.jpg?v=1724055940"
        },
        {
            name : "Murat Ç.",
            title : "Mükemmel..",
            comment : "Yeni evliyiz eşimle aramızda kilo farkı fazla olmasına rağmen gece eşimin dönüşlerini hissetmiyorum. Ayrıca yatağımı ozonla temizleyebilmek mükemmel.",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Murat Ö.",
            title : "Çok İyi",
            comment : "Hem teknolojisi hemde rahatligi muthis. Çok tesekkur ederiz.",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Hatice G.",
        title: "Aşırı Rahat ve Tavsiye Edilir",
        comment: "Sloth Bedding yatağımız aşırı rahat ve herkese tavsiye ediyorum. Ayrıca temizleme olayı var, yatak hep temiz kalıyor.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/eed45062a56943f7858c63b538899542.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/HATICE_G.MERSIN_.mp4_snapshot_00.13.238.jpg?v=1724055947"
        },
        {
            name : "Mustafa K.",
            title : "Çok İlgililerdi",
            comment : "Merhabalar, rahat bir yatak istiyordum, rahat ve hijyenik bir yatak geldi. Yatak bir cihazla k kendini temizleyebiliyor. Çok memnunum iyi ki almışım.",
            product : "Reboot Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Nagihan A.",
            title : "Temiz ve Kaliteli Uyku İçin",
            comment : "Yatagın temizlenebilir ve dogal malzemelerden yapilmis olmasi günün buyuk bolumunu yatakta geciren oglum ve uyku kalitesi icin cok buyuk bir avantaj. Tesekkur ediyorum:)",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
        name: "Hatice K.",
        title: "Bel ve Sırt Ağrılarından Kurtuluş",
        comment: "Merhabalar, biz Sloth Bedding’den 2 yıl önce bir yatak aldık. Fermuarlı bir pedi var, temizleme cihazı var, bel ve sırt ağrılarımız gitti. Çok severek kullanıyoruz.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/ea513cfb3ccb43e69c0f6e31dd49c969.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/HATICE_K._BURSA_OK.mp4_snapshot_00.03.249.jpg?v=1724055951"
        },
        {
            name : "Necmettin K.",
            title : "Dünyada İlk",
            comment : "Teknoloji meraklısıyım her sektörde öncü olan firmaları ve yenilikleri takip etmeyi severim. Bu yatağında temizleme teknolojisini çok mantıklı buldum denedim ve memnun kaldım.",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Nur Ö.",
            title : "Teşekkürler",
            comment : "Yatak rahatlığıyla konforuyla mest etti bizi. Gerçekten yatarken yokmuş hissi bulutların üzerinde uyuyormuş gibi hissettiriyor. Temiz ve konforlu bir uyku, ağrısız ve dinç uyanmanız için mutlaka tavsiye ederim.",
            product : "Logic Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
        name: "İlgi K.",
        title: "Çocuklarımız İçin Sağlıklı Uyku",
        comment: "Ben Sloth Bedding yatağımı kullanırken, gelişme çağında olan iki çocuğumun güne dinç başlaması ve omurga sağlıkları için tercih ettim. Temiz uyku, rahat uyku. Teşekkürler Sloth Bedding.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/92d0f881ff4844e48bc7e9fb50c41f0d.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/ILGI_K._KARAMAN_OK.mp4_snapshot_00.03.580.jpg?v=1724055956"
        },
        {
            name : "Önder S.",
            title : "S.Ö ve S.S",
            comment : "Uyku alışkanlıklarımı Sloth Beddingden önce Sloth Bedding'den sonra olarak ikiye ayırıyorum :) ",
            product : "Reboot Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Öykü K.",
            title : "Kızımız İçin",
            comment : "Kızımız için aldık ,çocuk gelişimi için doğru yatak arayışımızda karşımıza çıktı. çok memnunuz.",
            product : "Code Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
        name: "İpek Ö.",
        title: "Yorgunluk ve Sırt Ağrısından Kurtuluş",
        comment: "Yaklaşık 8 aydır Sloth Bedding Reboot modelini kullanıyorum. Bir arkadaş tavsiyesi üzerine aldım ve çok araştırdım. Eski yatağımda sabahları çok yorgun hissederek uyanıyordum, sırt ağrısıyla uyuyordum. Belirli zamanlarda yatak temizleme yapıyorum. Alerjik bir bünyem olduğu için odamı da temizliyorum. Artık çok rahat uyanıyorum.",
        product: "Reboot Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/b91c71d6ca7d48b692ff4706331447b1.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/IPEK_O._ISTANBUL_OK.mp4_snapshot_00.02.572.jpg?v=1724055960"
        },
        {
            name : "Özer D.",
            title : "Keşke",
            comment : "Keşke çok daha önce bu yastığı kullanmaya başlasaymışım. Çok memnunum.",
            product : "Future Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Saniye Z. ",
            title : "Temizlik",
            comment : "Temizlik bizim için çok önemliydi ve üstüne konfor eklenince çok doğru tercih yapmışız.teşekkürler",
            product : "Reboot Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
        name: "Kemal P.",
        title: "Air Clean Teknolojisi ile Memnuniyet",
        comment: "Sloth Bedding firmasının ürettiği Air Clean hava kanallı yatak teknolojisi olan bu yataktan aldık, komşumuz sayesinde. Biz çok memnun kaldık.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/30884b2d23ab4cefa8de62c78c5bce5f.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/KEMAL_P._ISTANBUL.mp4_snapshot_00.13.767.jpg?v=1724055964"
        },
        {
            name : "Seda Ş.",
            title : "Daha Ne Olsun!!",
            comment : "Bebeğimin odasını ayırmaya karar verdiğimde yatak arayışımda başladı. Yatağın üstünün ve içinin de temizlenebilmesi ile diğer alternatif markalara göre açıkara öne çıktı. Çok memnunuz temizlenebilen çocuk yatağı daha ne olsun.",
            product : "Code Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },

        {
            name : "Sena H.",
            title : "Çocuğum İçin En Doğrusu",
            comment : "Yatak yüksekliğimizle bile ilgilendiler. Yatağın temizlenebiliyor olması ve vücudu doğru desteklemesi gelişim yaşındaki çocuğum için çok önemliydi. Teşekkürler",
            product : "Reboot Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
        name: "Mehmet T.",
        title: "2023'ten Beri Memnuniyet",
        comment: "2023'ten bu yana kullandığım Sloth Bedding yatağım çok memnunuz. Tavsiyedir.",
        product: "Logic Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/aaaacefec18946f2ac770d6575d3984f.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/Mehmet_T.png?v=1724058610"
        },
        {
            name : "Serkan S.",
            title : "Alerjik ",
            comment : "Oğlum geceleri öksürük krzine girerdi ama bu problemi ortadan kalktı. Çok mutluyuz çok teşekkürler.",
            product : "Future Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Sermet T.",
            title : "Çok Başarılı",
            comment : "12 yaşındaki oğlumda gece sık sık uyanma problemi ve astım başlangıcı vardı.Yatağın temizlenebiliyor ve antialerjik olması bizi çok etkiledi. 15 gündür gece uyanma problemi bitti şuan çok mutluyuz.",
            product : "Reboot Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
        name: "Mehmet G.",
        title: "Öksürme ve Terleme Sorunlarına Son",
        comment: "Ben bu yatakta uyurken geceleri öksürmüyorum ve terlemiyorum. Ve güzel uyuyorum. Herkese tavsiye etmiş miniğimiz :D Biz sana teşekkür ediyoruz, Sloth Bedding olarak hep güzel uyu sen.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "https://cdn.shopify.com/videos/c/o/v/2330042b4557472db328d81e9704940e.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/MEHMET_G._ZONGULDAK_OK.mp4_snapshot_00.08.616.jpg?v=1724055969"
        },
        {
            name : "Sevil B.",
            title : "Bebek Yatağı",
            comment : "Bebeğimiz için yatak arayışımız vardı. Temizlik özelliği ve doğal lateks kullanılıyor olması sebebi ile tercih ettik. Çok memnunuz.",
            product : "Future Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Sevim G.",
            title : "Sporcuya Uygun",
            comment : "Yoğun idmanlarım sonrasında çok iyi dinlenebiliyorum benim için çok faydalı oldu. Teşekkürler.",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
    name: "Mehmet T.",
    title: "Bel ve Boyun Ağrılarından Kurtuluş",
    comment: "Merhaba arkadaşlar, ben Sloth Bedding'i 3 aydır kullanıyorum. Bizim için yatak, uyku günün en önemli şeyi. Yatak ararken bu yatakla tanıştık. Eşimde bel fıtığı sorunu var, bende boyun ağrıları çok oluyordu. Biz hemşireyiz, hep ayakta çalışıyoruz. Bu yatak bize çok iyi geldi, eşim ilaç kullanmayı bıraktı, benim ağrılarım geçti. Ben yastığını da aldım. Müşteri ilişkileri çok iyi, hep arıyorlar, soruyorlar, aşırı ilgililer. Her şey zamanında geldi. Sloth Bedding ailesine teşekkür ederiz.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/056cdd3b427d4e76b41ca291f146617d.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/MEHMET_T._SANLIURFA_OK.mp4_snapshot_00.06.472.jpg?v=1724057823"
},
        {
            name : "Simge Z.",
            title : "Çok İyi",
            comment : "Tereddüt ederek aldım. Sonuç çok iyi. ",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Şahin S.",
            title : "Taşıma Çantası",
            comment : "Paketlemeleri görsel olarak oldukça iyi ama yatağı taşırken yatak çantasının kulpları yırtıldı. Daha sonra kullanmak iyi olurdu. Yatak konforu ve teknolojisinden memnunuz.",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
    name: "Mehmet Ö.",
    title: "Yatak Temizliği ve Memnuniyet",
    comment: "Yatak temizliğimizi yapıyoruz. Şu anda yatak temizleniyor. Göstermek istedik. Sloth Bedding.",
    product: "Logic Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/7c246dfb1efa49b79f4536ed92073352.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/MEHMET_O._BALIKESIR_OK.mp4_snapshot_00.00.000.jpg?v=1724055974"
},
        {
            name : "Şeyma B.",
            title : "Bu Sefer Oldu",
            comment : "Oğluma başka markadan yatak almıştık yatakta ciddi bir koku vardı rahatsız olduk ve iade ettik. Sloth Bedding'e geçince uyku süremiz arttı ve gece terlemeleri en aza indi.",
            product : "Future Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Şuheda S.",
            title : "İlginize çok çok teşekkürler",
            comment : "Yatak, yorgan, yastık hepsinden çok memnun kaldım.  Herkese tavsiye ediyorum.",
            product : "Logic Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
    name: "Melisa E.",
    title: "Özel Ölçü ve Doğal Lateks Yataklar",
    comment: "Merhaba, Sloth Bedding'den çocuklarımın ranzası için özel ölçü olan iki yatak aldım. Doğal lateks olmasını istedim. Paketleme çok iyiydi, hızlı kargo ile çabuk geldi. İdeal sertlikte olan bu yataklar doğal ve mükemmel. Ayrıca müşteri hizmetlerinin ilgisi için teşekkürler.",
    product: "Future Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/f2106339c3ff47ae9e3f3240993f7a50.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/MELISA_E._ANTALYA_.mp4_snapshot_00.04.164.jpg?v=1724057856"
},
        {
            name : "Tolga Y.",
            title : "On Numara",
            comment : "Zorda olsa 12 yıllık yatağımdan ayrıldım. Keşke bu kadar beklemeseydim. On numara yatak",
            product : "Connect Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Tuba G. ",
            title : "Doğru Tercih",
            comment : "Müşteri hizmetlerinin detaylı soruları ile bizi yönlendirmesi sonucu çok doğru bir tercih yapmışız. Tavsiye ederiz.",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
    name: "Meral S.",
    title: "Air Clean Teknolojisi ve Ortopedik Konfor",
    comment: "Merhaba, bu yatağı tercih etme sebebim Air Clean teknolojisinin olması ve ortopedik bir yatak olma özelliğidir. Konforlu ve rahat bir uyku istiyorsanız gönül rahatlığıyla bu yatağı tercih edebilirsiniz.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/a4aa7da9c8a94beaba4fcd18f9584b6a.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/MERAL_S._ISTANBUL_OK.mp4_snapshot_00.07.276.jpg?v=1724057860"
},
        {
            name : "Tuğçe B.",
            title : "Ozon",
            comment : "Ozon ile temizleme fikri çok iyi. Çok memnun kaldım.",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Ulaş P.",
            title : "Ülkemiz İçin Mutluyum",
            comment : "Daha önce çok visco denemiştim ve hepsi terletiyordu. Müşteri hizmetleri bu visconun hava kanallı olduğunu problem yaşatmayacağını söylemişlerdi öyle de oldu. Teşekkürler.",
            product : "Slothy Visco Ortopedik Yastık",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
    name: "Merve Deniz B.",
    title: "Park Yatak ve Slowbi Memnuniyeti",
    comment: "Yataklarımızı Sloth Bedding olarak tercih ettik. Hem park yatak hem de Slowbi olarak aldım, yataklardan çok memnunuz. Her iki yatak için de alez de aldım. Kullanıyorum, zaten çok ilgili bir firma, yatak renklerimizi beraber seçtik. Yataklar rulo şeklinde geliyor, açması çok kolay, dokuları mükemmel.",
    product: "Future Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/638bfcddeec540ce9d4b10a49e6696ab.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/MERVE_DENIZ_B._DIYARBAKIR_OK.mp4_snapshot_00.03.663.jpg?v=1724057864"
},
        {
            name : "Ümit P.",
            title : "Öneriyorum",
            comment : "Takip ettiğim bir fizyoterapist çok fazla önerince dikkatimi çekti ve arayışta olduğum için aldım. Temizleme teknolojisi de yanında bonusu oldu. Çok çok memnunuz.",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Ümit Ş.",
            title : "Memnun Kaldım",
            comment : "Ürünü alalı 3 ay oldu. Gayet memnunum. Hiç sorun yaşamadım.",
            product : "Reboot Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
    name: "Mithatcan A.",
    title: "Ozon ile Temizlik ve Rahat Uykular",
    comment: "Merhabalar, 1 yıldır kullanmakta olduğumuz Code Air Clean modelini ozon ile temizliyoruz ve en rahat uykuları uyumak için hazırız.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/30db8c71a3814317b45dee2ff11e6e2e.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/MITHATCAN_A._MUGLA_OK.mp4_snapshot_00.07.081.jpg?v=1724057869"
},
        {
            name : "Vedat G.",
            title : "Hızlı ve Konforlu",
            comment : "Hızlı bir şekilde geldi, çantadan çıkarılması ve yatağa yerleştirilmesi kolaydı. Yatağın teknolojisi çok iyi oldukça rahatız.",
            product : "Reboot Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Yankı U.",
            title : "Beğendik",
            comment : "Nasılsa deneme süresi var beğenmezsek iade ederiz diye aldık ama rahatlığına ve teknolojisine inanamadık. Daha önceleri nerde uyuyormuşuz.",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
    name: "Muhammer E.",
    title: "2,5 Yıldır Rahat Uykular",
    comment: "2,5 yıldır Sloth Bedding yataklarını kullanıyorum. O kadar rahat bir yatak ki herkese tavsiye ederim. 65 yaşındayım, en rahat uykumu uyuyorum. Alınnnnn.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/2d9a10dd4df2441a8c7acb159fcc3f2f.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/MUHAMMER_E._ISTANBUL_.mp4_snapshot_00.02.651.jpg?v=1724057872"
},
        {
            name : "Yasemin D.",
            title : "Tüm Aile Tercih Ettiğimiz Marka",
            comment : "Önce oğlumuza sonra kendimize aldığımız inanılmaz konforlu yatak!Oğlum alerjik olduğundan temizlenebilir olması,benim için çok çok önemliydi.Siparişten kuruluma destek olan ekibe de çok teşekkürler :)",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Yasemin T.",
            title : "Lateks Yastık",
            comment : "Çağımızın hastalığı boyun düzleşmesi sebebiyle artan ağrılarıma çare olsun diye çok yastık değiştirdim ama sorunumu çözen yastık slothy lateks yastık oldu. Teşekkürler.",
            product : "Slothy Latex Ortopedik Yastık",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
    name: "Muhammet Rafi Ç.",
    title: "Çocuğum için En İyi Tercih",
    comment: "Çocuğum için Code Air Clean modelini tercih ettim ve çok memnunum. Teşekkürler Sloth Bedding.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/c5ec829882f4405282606b42358955e9.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/MUHAMMET_RAFI_C.KONYA_OK.mp4_snapshot_00.08.606.jpg?v=1724057876"
},
        {
            name : "Yavuz K.",
            title : "Güzel Uyanmak",
            comment : "Harika bir urun yapmışsınız bu yatağı aldıktan sonra bugüne kadar uyumadigimi fark ettim elinize sağlık teşekkür ediyorum.",
            product : "Connect Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Yavuz T.",
            title : "Alerjik Bünyeler İçin Harika",
            comment : "Eşimin alerji durumu sebebi ile tercih etmiştik, alışmamız zaman alır diye düşünürken ilk günden itibaren konforlu uyku uyuyoruz. Yanındaki ozon cihazı ile gardrobumuzu bile havalandırıyoruz.",
            product : "Logic Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
    name: "Murat A.",
    title: "En İyi Yatak Deneyimi",
    comment: "Sloth Bedding şimdiye kadar kullandığımız yataklardan en iyisi. Üzerindeki hava alan kumaş çıkıp yıkanabiliyor, aleze gerek yok. Air Clean teknolojisi de var, odayı da temizliyor. Doğal lateks bir yatak. Code yatak aldık biz. Bizim yatağımız özel yapıldı, kilolarımıza göre ayarlandı. Çok memnunuz.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/07a49013ea2f48a9905af6e83666cf88.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/MURAT_A._CORUM.mp4_snapshot_01.04.472.jpg?v=1724057880"
},
        {
            name : "Yeliz K.",
            title : "Doğru Karar",
            comment : "Yatak arayışıma başladığımda sırt ağrılarım oldukça fazlaydı. Müşteri hizmetlerine ulaştığımda problemlerimden bahsettim ve beni lateks modele yönlendirdi. Gerçekten vücudumdaki ağrılarım azaldı. Tavsiye ederim.",
            product : "Code Air Clean",
            star : 5,
            image : true,
            video: "",
            poster: ""
        },
        {
            name : "Yunus Ç.",
            title : "Aradığımı sonunda buldum!!",
            comment : "Çok bilindik markalardan yatak tercihlermize rağmen aradığımız yatağı bulamamıştık. Firmaya ulaşarak şikayetlerimden ve aradıklarımdan bahsedince bana en uygun yatak olarak Code da karar kıldık ve yatak arayışım son buldu.",
            product : "Code Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
    name: "Naira R.",
    title: "Bel, Sırt ve Boyun Ağrılarından Kurtuluş",
    comment: "Uzun zamandır bel, sırt ve boyun ağrısı ile uyanıyordum. Yeni bir yatak araştırdım ve Sloth Bedding ile tanıştım. Boyun ağrım için yastığını da aldım. Bir hafta sonra bütün ağrılarım geçti. Gerçekten alın ve çok memnun kaldım.",
    product: "Logic Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/a49245e9a8bc44a7ab2814da0662d0ef.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/NAIRA_.R_ISTANBUL.mp4_snapshot_00.04.096.jpg?v=1724057887"
},
        {
            name : "Zeynep D.",
            title : "Doğal Kılıf",
            comment : "Oğlumun yatağının üstüne doğal yün katmanlı olan Fliptop Woolu satın aldık ve oldukça memnun kaldık. Hem konforunu arttırdı hem de terlemelerini kesti. Teşekkürler.",
            product : "Fliptop Wool",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
            name : "Zeynep E.",
            title : "Mükemmel İlgi",
            comment : "İnternette karşıma çıktı merak ettiğim için aradım çok ilgili yaklaştılar. Ürünü aldım ve sonuç beklediğimden bile iyi çıktı. Teşekkürler.",
            product : "Connect Air Clean",
            star : 5,
            image : false,
            video: "",
            poster: ""
        },
        {
    name: "Neslihan Ö.",
    title: "Toz ve Alerjenlerden Kurtuluş",
    comment: "Merhaba, yatak alma ve değiştirme sebebim, maytlar ve tozlarla uğraşmak istememdi. Yatak üzerinde rahat uyumak, hiç çökmeme olması güzel. Yorgan ve yastıkları da kullanıyorum. Herkese tavsiye ederim.",
    product: "Logic Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/97cb98f333df450c80b4181de508bb95.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/NESLHAN_O._BURSA_OK.mp4_snapshot_00.16.353.jpg?v=1724057890"
},
{
        name: "S. Y.",
        title: "ÇOK İYİ MEMNUNUZ",
        comment: "MERHABA. TANIDIĞIMIZ HERKESE TAVSİYE EDİYORUZ. ÇOKKK MEMNUNUZ HATTA OĞLUMUZA DA ALMAYI DÜŞÜNÜYORUZ TEŞEKKÜRLER.",
        product: "Logic Air Clean",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "Büşra Öznal",
        title: "konforun tek adresi",
        comment: "Merhaba işimden dolayı sürekli uykusuzluk ,bel ,sırt ağrıları çekiyordum .sloth bedding logic air clean yatak aldığımızdan beri ağrılarım yok denecek kadar azaldı daha rahat uyku çekebiliyorum çok rahat ve konforlu .bu konforu bana ve eşime sunduğu için slothbeddinge teşekkür ederim...",
        product: "Logic Air Clean",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Nida P.",
    title: "Çökmeyen ve Temizlenebilen Yatak Deneyimi",
    comment: "Merhaba, benim eski yatağımda çökmeler oluyordu. Bu yatakta farklı bir yay sistemi olduğunu söylediler. Vücut ağırlığını rahat ve çökmeme olmadan taşıyabildiğini belirttiler. Yatak ozon gazı ile temizlenebiliyor, böylece tozlardan ve alerjenlerden arınıyor. Üzerindeki kılıf çıkıp yıkanabiliyor. Ben çok memnunuyum, herkese tavsiye ederim.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/a6a080c9bf2249cda2d7a6a70d95e745.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/NIDA_P._ELAZIG_OK.mp4_snapshot_00.05.861.jpg?v=1724057894"
},
{
        name: "Rabia Kılıç",
        title: "Çok kaliteli",
        comment: "Çok kaliteli",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
{
    name: "Nur Ç.",
    title: "Çocuğumuz İçin İdeal Yatak",
    comment: "Sloth Bedding'den aldığımız yataktan çok memnunuz. Çocuğumuz için almıştık. Temizleme yapıyoruz, şu anda yatak temizleniyor. Alacak olan kişilere öneriyoruz.",
    product: "Future Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/f28612c3a6cf4eb4a861fb05ae80217c.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/NUR_C._SINOP_OK.mp4_snapshot_00.14.297.jpg?v=1724057898"
},
{
        name: "S. B.",
        title: "İLGİ VE ALAKA MÜHTEŞEMMM",
        comment: "Merhaba biz Sibel&Bora çelik ,uzun bir süre araştırdıktan sonra yaklaşık 3 ay kadar önce karar verip aldığımız sloht bedding yatağımızı kişiselleştirmek istedik ve isteğimiz doğrutusun da üretim yapılıp teslim edildi . Ancak yatağı biraz kullandıktan sonra bize uygun olmadığını anladık vee sloth bedding den safiye hanımla görüşüp durumu anlatınca , hemen değişimi sağladılar ve isteklerimiz doğrultusunda gönderilen yataktan bu sefer memmnun kaldık .ilgi ve alaka çok iyi ve değerli ,ürünlerinin de sonuna kadar arkasındalar müşteri memnuniyeti odaklılar sizin için en uygun yatağı teslim eden kadar ilğileniyorlar .Yaşadığımız bu deneyimi paylaşmak istedik ve herkese bu yatağı çok rahat tavsiye edebiliriz. TEŞEKKÜRLER .",
        product: "Code Air Clean",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Ogün D.",
    title: "Rahat ve Memnuniyet Verici Yatak",
    comment: "Sloth Bedding yatağımızı yaklaşık 1 ay önce aldık. O kadar memnunuz ki, o kadar rahat ki. Temizleme özelliği var. Çok teşekkür ederiz Sloth Bedding.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/afe6e6fd8dd542c1ae264b174ebdcbb0.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/OGUN_D.ISTANBUL.mp4_snapshot_00.11.898.jpg?v=1724058009"
},
{
        name: "S. E.",
        title: "bebeğim için en kalitelisi",
        comment: "Uzun araştırmalar sonucunda sizden park yatağımız için sipariş verdim. Kendi çantasında vakumlu olarak geldi ve açtığımda gerçekten o kaliteyi hissettim. Yumuşacık tensel kumaşıyla bebeğim çarşafsız bile terlemedi ayrıca çökme göçme de yok. Kalınlığı da gayet ideal. piyasadaki en kaliteli bebek yatağı bu bence. Bebeğim uykularındaki rahatlığı fark etmek çok güzel. Teşekkürler sloth bedding:)",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Onur A.",
    title: "Sırt ve Boyun Ağrısına Son",
    comment: "Merhabalar herkese, boyun ve sırt ağrısı çeken biri olarak bu yatak en iyisi. Yanındaki temizleme cihazı da yatağı çok özel yapıyor. Piyasadaki en iyisi. Yatağın yüzeyi ve yapısı Sloth Bedding'i tek yapıyor. Teşekkürler.",
    product: "Logic Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/75e1209f33454858bcf06a5290557c21.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/ONUR_A._AYDIN.mp4_snapshot_00.06.015.jpg?v=1724058012"
},
{
        name: "OKTAY KIRAÇ",
        title: "Çok memnunuz",
        comment: "Sırt ağrılamız geçti. Çok memnunuz İyi ki almışız 👍",
        product: "Logic Air Clean",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
{
    name: "Özcan B.",
    title: "Mutlu ve Rahat Uyku",
    comment: "Merhaba Sloth Bedding ailesi, yatağımızdan çok memnunuz. Oğlumuz da bu yatakta uyumaktan mutlu. Teşekkürler.",
    product: "Reboot Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/bbe06345109746c0a7108614ae6a4a3b.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/OZCAN_B._ISTANBUL_.mp4_snapshot_00.26.484.jpg?v=1724058016"
},
{
        name: "Banu",
        title: "Teşekkür",
        comment: "Bundan üç ay kadar öce boyun düzleşmesi için bu yastığı aldım, çok şidettli ağrım vardı. Gerçekten ağrım geçti. Yorum yapmaya üşenmiştim itiraf ediyorum ama artık farz oldu. Şöyle ki yastığın kılıfının fermuarı bozuldu. Markayı aradım yedek kılıf satıyor musunuz diye. Hayır satmıyoruz adresiniz verin biz size gönderelim dediler hiç bir ücret ödemeden kargo dahil ışık hızı ile yeni kılıfım geldi. Böyle bir marka böyle bir satıcı ve böyle kalite ürünleri olduğu için teşekkürler sloth bedding",
        product: "Slothy Visco Ortopedik Yastık",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Özlem B.",
    title: "Hijyenik ve Rahat",
    comment: "Merhabalar, Sloth Bedding'den çok memnun kaldığımızı göstermek için bu videoyu çekiyorum. Üzerinde böyle bir kılıf var, çıkarılıp yıkanabiliyor. Çok hijyenik ve temizlik açısından çok rahat. Hatta başka yerlere gittiğimizde en çok kendi yatağımızı özlüyoruz. Tavsiye ederiz.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/9addc188b9c74864a21feb91d0e5bb98.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/Ozlem_B..png?v=1724058611"
},
{
        name: "Sibel Çelik TURYAP CİTY",
        title: "Teşekkürler",
        comment: "Şu ana kadarki süreçte yataktan memnunuz. Özellikle satın alma sürecinde destek kısmı çok ilgiliydi . Müşteri memnuniyeti üst düzeyde . Teşekkürler",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
{
    name: "Pınar Korkmaz G.",
    title: "Rahat ve Temizlenebilir",
    comment: "Merhabalar, oğlum için aldığımız Sloth Bedding yatağımız Air Clean modelini kullanıyoruz. 3 ayda aralıklarla temizliğini yapıyoruz. Oldukça da rahat bir yatak.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/05db4c3e86ba4bfaa1ae49bd6fca0388.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/PINAR_KORKMAZ_G._ISTANBUL_OK.mp4_snapshot_00.03.456.jpg?v=1724058073"
},
{
        name: "Beste Beyit",
        title: "Bebeğimin uykusu düzeldi",
        comment: "Park yatak içinde gelen yatağı kullanıyorduk, çökme yaptığını görünce değiştirmeye karar verdim. Meğer ne kadar kalitesiz bir sünger parçasında yatırıyormuşuz bebeğimizi. Slowbie’ye geçtiğimiz gün deliksiz uyudu. Bebeğim çok terlemesine rağmen bu yatağın üzerinde hiç terlemiyor. İki taraflı uzun süre kullanılması da çok güzel. Çok kaliteli bir ürün, iyi ki almışım.",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
{
    name: "Recep Gökhan K.",
    title: "Kendini Temizleyen Yatak",
    comment: "Selamlar, size aylardır araştırmalarım sonucunda çok memnun kaldığım yatak tavsiyesinde bulunmak istiyorum. Beni en çok etkileyen tarafı dünyada bir ilk olan kendi kendini temizleme özelliğinin olmasıydı. 100 gün deneme süresi var. Çocuğunuz veya kendiniz uyurken tıkanma sorunu yaşıyorsanız bu yatak tam sizlik. Biz çok memnun kaldık. Tavsiye ederiz.",
    product: "Future Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/f3106a4223454df6b500d2776bd9372b.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/RECEP_GOKHAN_K.SAMSUN_OK.mp4_snapshot_00.07.851.jpg?v=1724058077"
},
{
        name: "Ali Yildirim",
        title: "mükemmel paketleme slothbedding )))",
        comment: "Yatak geldi.kargolama gayet özenliydi özellikle kendi koruma kılıfı olması ayrıca mutlu hissettirdi.ilginiz ve soruların hepsine döndüğünüz için ayrıca teşekkür ederim.yatağın yumuşaklığı ve konforu gayet ideal özellikle kendini temizlemesi bizim için büyük artısı oldu.iyi çalışmalar kolay gelsin 🫠",
        product: "Future Air Clean",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Rüştü Ahmet A.",
    title: "Rahat ve Temizlenebilir",
    comment: "Yatağımızdan çok çok memnunuz. Her 2 ayda bir temizliğini yapıyorum, yatak yeni oluyor. Bu cihaz odayı da temizliyor. Bel ve boyun ağrılarım hepsi geçti. Sertlik ve yumuşaklık ayarı yapılabiliyor. Tavsiye ederiz.",
    product: "Logic Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/d004826d3a2a479faabaf47a4c9e9af3.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/RUSTU_AHMET_A._YALOVA.mp4_snapshot_00.02.087.jpg?v=1724058081"
},
{
        name: "Chjjk Fbjjkk",
        title: "rahat uyuyoruz:)",
        comment: "merhabalar, biz eşimle gece uykusu uyayaman iki çiftiz taki slothbedding yataklarıyla tanışana kadar .hem rahat uyuyoruz hemde nefes alabilen dokusu ile uykudaki huzuru bulduk . bu arda biz logic yatak tercih ettık .hem kışlık hemde yazlık kullanılması na bayıldık . kesinlikle alın ...",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
{
    name: "Safa Y.",
    title: "Rahat ve Sorunsuz",
    comment: "Merhaba, bu videoyu Sloth Bedding bebek yatağını size göstermek için çekiyorum. Biz çok memnunuz. Biz 6 aydır kullanıyoruz. Sorunsuz geldi, cihazla yatağı temizliyoruz. Tavsiye ederiz.",
    product: "Future Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/3ad19b51e50847138262de3c9967645c.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/SAFA_Y.SAMSUN.mp4_snapshot_00.07.225.jpg?v=1724058085"
},
{
        name: "M. İ. Ö.",
        title: "sağlıklı ve hijyenik tek yatak",
        comment: "2 yaşındaki bebeğimiz için future air clean yatağı tercih ettik bebeğimiz kısa sürede yatağına alıştı . Bizde yanına uzandığımızda rahatlığını hissedebiliyoruz oldukça memmnunuz )",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
{
    name: "Salih O.",
    title: "Özellikle Temizlik Özelliği",
    comment: "Güvenle çocuklarımız için tercih ettiğimiz Sloth Bedding yatakları birçok özelliğe sahip. Hava kanallı temizleme teknolojisinin olması en önemli tercih sebebim diyebilirim. Air Clean makinasıyla tavsiye edilen dönemlerde yataklarımızı mikroorganizmardan arındırıyoruz. Aynı markanın çocuk yastıklarını da tercih ettik. Anti-slip özelliği ve yıkanabilir kılıfların olması beni bir baba olarak çok memnun etti.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/8cdcb7c3de264becb0c9ee7c4d20d676.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/SALIH_O._ISTANBUL_OK.mp4_snapshot_00.02.794.jpg?v=1724058089"
},
{
        name: "Büşra Aksu",
        title: "Harika slothbedding kalitesi",
        comment: "Bebeğim için yatak arayışındayken tavsiye üzerine tanıştım slothbedding ile omurga gelişimini destekleyen yapısı, nefes alabilen sağlıklı tencel kumaştan ve yıkanabilir kılıfa sahip olması, en birincil özelliklerinden bizim için, memnuniyetle ve sağlıkla kullanıyoruz, %100 tavsiye :)",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Saniye G.",
    title: "Rahat ve Hijyenik",
    comment: "Evdeki ilk yatağım olarak tercih ettiğim Sloth Bedding yatağımı uzun araştırmalar sonucunda buldum. Böyle aralıklı olarak temizliğini yapıyoruz. Üst dokusu çok hoş, rahat, çıkarılıp yıkanabiliyor. Çok memnun kaldığım için yastıkları da aldım. Tavsiye ederiz.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/53e14fcd24e647b589cfe9c24430ad19.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/SANIYE_G._ISPARTA_OK.mp4_snapshot_00.28.333.jpg?v=1724058093"
},
{
        name: "Dilcan akpınar",
        title: "NEDEN SEÇTİK",
        comment: "özel ölçü istedik yaptılar, yerine tam oldu ,yatak yerde olduğu için kalınlığı içime çok sindi ve ozonla temizlenmesi benim için çok önemli , bebeğim için en iyisini seçtim içim çok rahat ...",
        product: "Future Air Clean",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Selin Ergün K.",
    title: "Kaliteli ve Kullanışlı",
    comment: "Merhabalar, oğlumuz kendi odasında yatmaya başladığından beri onun için kaliteli bir yatak arayışındaydık. Bu arayışımız sonucunda yolumuz Sloth Bedding Air Clean yataklarıyla kesişti. Yatak ideal sertlikte ve temizlenebiliyor. 2 yaş geçtikten sonra oğlumuza Sloth Bedding'den yastık da aldık. Keten çantalarla geliyor ve bunu her yerde kullanabiliyoruz. Tavsiyedir.",
    product: "Future Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/aad7a653a8f347b38644c0079f723411.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/SELIN_ERGUN_K._ISTANBUL_OK.mp4_snapshot_00.04.934.jpg?v=1724058098"
},
{
        name: "Süheyla Karınca Altan",
        title: "bebeğim en iyisi",
        comment: "Bebeğim için iyi ve sağlıklı bir yatak arayisindayken annebebekdoktoru Gökçe Mat sayesinde bu marka ile tanıştım,Air Clean teknolojisi sayesinde kendi kendini temizlemesi tercih sebebim oldu.Alali birkaç ay oldu ve bir sıkıntı yaşamadık,bebeğimiz de yatağını sevdi🫠",
        product: "Future Air Clean",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Semih Apak",
    title: "Harika Bir Yatak",
    comment: "Merhaba, yatığımızdan çok memnunuz. İyi ki Sloth Bedding. Number one.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/23cca45c62394e15ad3e7c25c6c92d4b.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/SEMIH_APAK_IZMIR.mp4_snapshot_00.07.265.jpg?v=1724058104"
},
{
        name: "Seda Altuntaş",
        title: "harika bir yatak",
        comment: "2 yaşındaki kızım için hem airclean yatağı hem de visco kids yastığı aldık. Yatak gerçekten çok rahat.nerden mi biliyorum çünkü kızımla uyuyana kadar bende yatıyorum (hatta bazen yanında uyuyakaldığım zamanlarda oluyor :)) öğlen uykularında mutlaka uyanırdı ama bu yatağa geçtiğimizden beri 2 saat deliksiz uyuyor. Bunda yatağın çok büyük payı olduğunu düşünüyorum. Güvenle alabilirsiniz.",
        product: "Future Air Clean",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Semih G.",
    title: "Sağlıklı ve Temiz Bir Yatak",
    comment: "Merhabalar, bundan 2 sene kadar önce yeni doğan oğlumun sağlıklı bir yatakta büyümesi için araştırma yaptım ve Sloth ile karşılaştım. Özellikle bu markayı seçme sebebim temizlik yapılabilmesi. Maytlar ve tozlardan arındırma yapılabilmiş olması. Çok memnun kaldım. Alacak olan varsa hakkını veren bir yatak tavsiye ederim. Çocuğum rahat, ben de.",
    product: "Future Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/3ef364b103524a1e829f0411636b11bb.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/SEMIH_G.ISTANBUL.mp4_snapshot_00.02.225.jpg?v=1724058108"
},
{
        name: "Chjjk Fbjjkkk",
        title: "merhabalar",
        comment: "Kızımda alerji çıktı toza ve alerji yapan her şeye , slothbedding karşıma çıkınca kendi kendine temizleme özelliği beni cezbettiİyi ki de aldık kızım için güzel bir yatırım oldu o yatağında mutlu ,ben mutlu Teşekkürler sloth bedding.",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
{
    name: "Serpil A.",
    title: "Ozonla Temizlenen Konforlu Yatak",
    comment: "Kızımız için bir yatak arayışına girdiğimizde çok farklı marka ve model bulduk. Sloth Bedding de en çok etkilendiğimiz şey, yatağın ozonla temizlenmesiydi. Alerjik çocuklar için ideal bir yatak, çok konforlu. Ayrıca biz çok memnunuz.",
    product: "Future Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/1d3a7d39d78243cbaadf12a685c5a6bb.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/Serpil_A..png?v=1724058610"
},
{
        name: "Aslıhan Asil Akça",
        title: "Mükemmel",
        comment: "2 yaşında olan kızımız için yatak araştırması yaparken karşılaştık. Doğal lateks oluşu ve temizlenebiliyor olması bizi cezbetti. Ayrıca sorularımıza da çok net ve hızlı cevaplar aldık. Yaklaşık 4 aydır kullanıyoruz ve çok memnunuz, rahatlıkla tavsiye ederiz. Her şey için çok teşekkür ederiz.",
        product: "Future Air Clean",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Seyhan K.",
    title: "Konforlu ve Temiz Uykunun Anahtarı",
    comment: "Merhaba, Sloth Bedding yatağımızı severek kullanıyoruz. Hep temiz uyuyabilmek bir insan için en konforlu yaşam şekli bence. Çok memnunuz. Alın ve sadece uyuyun. Yastıkla beraber kullanıyorum.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/dcbdd33b02a24636afea269f6781ffdc.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/SEYHAN_K._ISTANBUL_OK.mp4_snapshot_00.09.584.jpg?v=1724058122"
},
{
        name: "halit talha türe",
        title: "Alışık olduğumız Slothbedding kalitesi",
        comment: "Ailece zaten Slothbeddingin yastıklarını kullanıyoruz bu sebeple yeni doğan bebişimiz için de bu yatağı tercih ettik. Gayet memnunuz.",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Sümeyye K.",
    title: "Rahat ve Güvenli Uyku",
    comment: "Merhabalar, Sloth Bedding'den aldığımız Future Air Clean yataktan çok memnunuz. Kızım çok rahat uyuyor. Temizlik teknolojisiyle de içimiz çok rahat.",
    product: "Future Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/15e0b15c4d2e43f0833c0bcb0219f65f.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/SUMEYYE_K._STANBUL_OK.mp4_snapshot_00.03.125.jpg?v=1724058126"
},
{
        name: "S. E. S.",
        title: "Kaliteli ve rahat",
        comment: "Uzun araştırmalar sonucunda sloth bedding den park yatağımız için sipariş verdim. Kendi çantasında vakumlu olarak geldi ve açtığımda gerçekten o kaliteyi hissettim. Yumuşacık tensel kumaşıyla bebeğim çarşafsız bile terlemedi ayrıca çökme göçme de yok. Yüksekliği de gayet ideal. piyasadaki en kaliteli bebek yatağı bu bence. Teşekkürler sloth bedding;)",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Tuna S.",
    title: "Beklediğim Her Şey Var",
    comment: "Bu yatakta beklediğim her şey var; hem temiz hem çok rahat. Yatağımdan çok memnunum. Sloth gibi uyuyorum.",
    product: "Future Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/aa1b099abc354a1bac14f0ea260e8a1b.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/Tuna_S..png?v=1724058610"
},
{
        name: "FİLİZ K.",
        title: "TEŞEKKÜRLER SLOTBEDDİNG",
        comment: "Biz ikiz kızlarımız aldık çok memnunuz her detayı güzel düşünülmüş özel olarak tasarlanması harika hem park yatak olarak kullanıyoruz hem de yer yatağı olarak kullanıyoruz kızlarımız çok rahat uyuyabiliyor artık .firma olarak çok ilgililer teslimattan sonra bile arandık .tam bir 5 yıldız .teşekkürler.",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
{
    name: "Veli G.",
    title: "Tavsiye Ederiz",
    comment: "Merhaba, Sloth Bedding yatağımızdan çok memnunuz. Tavsiye ederiz. Parasını hak eden bir yatak olmuş. Firma ve müşteri ilişkileri çok iyi. Teşekkürler.",
    product: "Reboot Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/3e871dfad5df4ee695694de0ad474467.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/VELI_G._IZMIR.mp4_snapshot_00.12.447.jpg?v=1724058300"
},
{
        name: "Gamze Güler",
        title: "Kalite ve konfor",
        comment: "Nuna park yatak kullanıcısıyız ve ölçülerine en yakın bu yatak olarak sipariş verdik ve ertesi gün firma yetkilileri arayarak önceki tecrübelerine dayanaraktan park yatağınız net ölçüsünü verin yada park yatağı numune olarak gönderin dediler biz de ölçüleri verdik Sloth beddinge sağolsunlar birebir aynı ölçülerde yaptılar. Yataktan çok memnunuz ve bebeğimiz huzurlu bir şekilde uyuyor. Bir çok firmadan yatak almış ve kötü deneyimle sonuçlanmış olarak bu yorumu yazıyorum tekrar ilgi ve alaka için teşekkür ederiz.",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Yakup S.",
    title: "Çok Memnunuz",
    comment: "Merhabalar, yaklaşık 5 aydır Sloth Bedding yatağını kullanıyoruz. Öncelikle mevcut yatağımız visko idi, çok bel ve sırt ağrısı yapıyordu. Dinlenmeden uyanıyorduk. Sonra katmanlı yatak almak istedik ve Sloth ile tanıştık. Doğru bir karar vermişiz. Çok memnunuz. Ayrıca Sloth Bedding yatağını kullanıp doğru yorum yapmış olan herkese çok teşekkürler.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/6549d04ab5d748a0b3e718cd3ff33e3c.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/YAKUP_S._ISTANBUL_.mp4_snapshot_00.49.926.jpg?v=1724058304"
},
{
        name: "Elif Eralp",
        title: "Mükemmel kalite",
        comment: "Park yatağımız için aldık. Kalitesine bayıldım. Çift taraflı olması çok iyi düşünülmüş bir özellik bence. Fiyatını hakeden bir ürün kesinlikle.",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Yasemin Y.",
    title: "Temiz ve Hijyenik",
    comment: "Merhaba, Sloth Bedding'in yaklaşık 6 aydır kullandığım yatağımı görüyorsunuz. Temiz ve hijyenik bir yatak. Kedim de çok memnun, bakın 😊 Biz de çok memnunuz.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/346a025e6c424e71b846c276e8ff5711.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/YASEMIN_Y._ISTANBUL_OK.mp4_snapshot_00.09.170.jpg?v=1724058309"
},
{
        name: "Alpe",
        title: "Çok iyi bayildim",
        comment: "Abi çok iyi yapmışsınız",
        product: "Future Air Clean",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
{
    name: "Yusuf D.",
    title: "Bel Fıtığı Ağrılarında Azalma",
    comment: "Merhabalar, Sloth Bedding'den hem yatak hem de yastık satın aldım 6 ay önce. Bel fıtığı teşhisi kondu ve ağrılarla uyanıyordum. Fakat bu yatakla birlikte ağrılarımda %80 azalma oldu. Çok memnunuz, üretenlere teşekkür ediyoruz.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/a52c8b6d54e647c2b3f79dbd6c895bec.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/YUSUF_D._OK.mp4_snapshot_00.20.444.jpg?v=1724058313"
},
{
        name: "Selvinaz Güdül şahin",
        title: "Teşekkür ederiz",
        comment: "Markanın bebek yatağını almıştım çok memnun kaldım yastık hediye gönderildi zaten almayı düşündüğüm bir üründü firmaya çok teşekkür ediyorum diğer ürünlerini de gönül rahatlığıyla alabilirim ilgi ve alakası için firmaya ayrıca teşekkür ederim ürünlerinin her türlü arkasında olan bir marka..",
        product: "Slothy Bamboo Bebe Yastık",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
{
    name: "Zeynep B.",
    title: "Keyifli Kullanım ve İyi İlgi",
    comment: "Merhabalar, bugün size aylardır keyfine vardığım yatağımdan bahsetmek isterim. Sloth Bedding hem yerli bir firma olması hem de birçok farklı özelliği olmasıyla gönlümü fethetti. Kişiye özel tasarlanması ve en çok da çalışanların göstermiş olduğu ilgiye teşekkür ederim.",
    product: "Reboot Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/1f34a3d73dd445fa83149b1af63239b8.mp4",
            poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/ZEYNEP_BUSRA_B._KOCAELI_OK.mp4_snapshot_00.07.288.jpg?v=1724058318"
},
{
        name: "Müjde t.s.",
        title: "Mükemmel 😎",
        comment: "Sloth bedding yataklarını daha önce hiç kullanmamış ve varlığından haberi olmayan biri olarak doğacak olan bebeğim için en iyi yatağı araştırırken instagramda reklamlarına denk gelip merak edip uzun süren araştırmalarım sonrası almaya karar verdim ve iyi ki almışım dediğim bir tercih oldu bebeğim için. Kılıfının çıkarılıp yıkanabilir olması harika, kumaşı dokusu kalitesi tek kelime ile benzersiz, bir tarafı ilk 6 ay için olması gereken sertlikte diğer tarafı ise 6 ay sonrası ortopedik rahatlığı sunuyor bebeğime. Kargo çok hızlı ve paketleme çok iyiydi yatak çantasından bile bu işi ne kadar önemsedikleri ve kaliteli yaptıklarını gösteriyor çok memnun kaldık. En kısa sürede kendi yatağımı da değiştirip burdan almak istiyorum. Sadece fiyatlar piyasaya göre biraz pahalı ama hakettiğini düşünüyorum🙏 teşekkürler sloth bedding:)",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "Selvinaz Güdül şahinn",
        title: "En doğru seçim…",
        comment: "Yatağı bebeğim için çok araştırarak tercih ettim başlangıçta tereddütlerim vardı ama kullanırken yaptığım en doğru seçim olduğunu görüyorum kumaşının yıkanabilir olması büyük avantaj 6aydır herhangi bir deforme yaşamadık..gelecekte diğer ürünlerini de almayı düşünüyorum umarım fiyatlarda daha makul olur bu ürünleri herkes keşfetmeli..",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "Gürsel Güler",
        title: "Mükemmel",
        comment: "Bebeğimizin yataği icin aldık ve çok memnun kaldık. Bebeğimiz kolları 180 derece açik mışıl mışıl uyuyor. Kendi yatağımızı sloth beddingten değiştirmeye karar verdik. Urun ve hizmet kalitesi mükemmel.",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "Başak Ergül",
        title: "Tek kelimeyle kalite:)",
        comment: "Henüz bebeğimiz doğmadığı için kullanmaya başlamadık ama kullananların tavsiye üzerine aldık. Gerçekten çok kaliteli bir ürün. Hem çok hızlı kargolandı hem de paketlemesi çok özenli geldi. Kaliteli bir bez çantanın içinde geliyor. Daha açmadan kalitesi belli oluyor. Teşekkürler sloth bedding.",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "R. K.",
        title: "Harika",
        comment: "Bebeğimiz henüz dünyaya gelmediği için ürünü kullanmadık ama kullanan arkadaşların tavsiyesi ile aldık. İlk izlenimlerimiz ürün kalitesi gerçekten kendini belli ediyor. Kargolanması ve çanta detayı gerçekten harika. İnşallah bebeğimizde sever ve güzelce uyur teşekkürler sloth bedding :)",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "D Erdom",
        title: "Güzel",
        comment: "5 aydır kullanıyoruz. Oldukça memnunuz. Ayrıca müşteri ile ilişkilerine 5 yıldız az kalır. Çok teşekkürler.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "Saniye Gümüş",
        title: "Artık bel ağrısı problemi yok",
        comment: "Çok memnunuz... uykularımız çok rahat ve huzurlu. Artık bel ağrısı problemi yaşamıyorum sabahları daha sağlıklı uyanıyorum.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "Elif Güler Ayva",
        title: "Tavsiye",
        comment: "Yaklaşık 6 aydır kullanıyoruz.Kızım için aldım ve iyi ki bu yatağı almışım iyi ki sizi tercih etmişim. Çok memnun kaldık almayı düşünen herkese gönül rahatlığıyla tavsiye ederim.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "Figen Sen",
        title: "Memnuniyet",
        comment: "İki yıldır kullanıyorum. Daha önceki yataklara göre uyku kalitesindeki fark anlaşılıyor.Teşekkürler.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "Fozgur",
        title: "Memnuniyet",
        comment: "Çok memnunum, oğlum için aldım tek kişilik odasında dokusu temizliği her şeyi ile harika! Herkese çok tavsiye ederim.",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "Mehmet Çelik",
        title: "Uyku kalitem",
        comment: "Uyku kalitemle hayat kalitem doğru orantılı arttı teşekkürler Sloth Bedding :)",
        product: "Code Air Clean",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
  name: "N** Y**",
  title: "Çok rahat ve kaliteli",
  comment: "4,5 yaşındaki kızım için aldım. Harika bir çanta ile gönderildi. Sipariş verdim ertesi gün elimdeydi. Tam beklediğim gibi çok rahat. Boyutu yüksekliği çocuklar için ideal. Oldukça kaliteli. Çok çok beğendim. Huzurla uyusun yavrular…",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "**** ****",
  title: "Hijyenik ve ideal",
  comment: "Yastığı almaya uzun araştırmalarım sonucu karar verdim. Mesele çocuk sağlığı ve hijyeni olunca ekstra hassas davranıyorum. Çocuğum icin yetişkin yastıkları yüksek ama bebek yastıkları küçük geliyordu. Ürün elime ulaştıktan sonra fazlasıyla memnun kaldım. Tam olarak ihtiyacım olan buydu. Yanında göndermiş oldukları çanta çok kullanışlı. Kargo sorunsuz ve satıcı ilgliydi. Herkese şiddetle tavsiye ederim.",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "i** E**",
  title: "Tam ideal",
  comment: "2,5 yaşındaki kızım için aldım tam ideal severek kullanıyoruz",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "Kübra Ü.",
  title: "Yumuşacık ve esnek",
  comment: "Oğluma aldığımız ilk yastık ve artık zamanı da geldiği için aldık yumuşacık esnek ve içe batma olmuyor kesinlikle 👍😉",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "Ü** b**",
  title: "Sağlık ve rahatlık",
  comment: "Yastık ve yatak ihtiyacımızdan dolayı çokça araştırma fırsatım oldu.bu ürüne rastladım.saglıgı ve rahatlığı ön planda tutan ürünler oldugu icin tercih ettim herseyden önce.Teşekkür ederiz.",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "**** ****",
  title: "Çok memnunuz",
  comment: "Kızım için aldım çok memnunuz",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "s** y**y",
  title: "Terleme problemine çözüm",
  comment: "Öncelikle kızımın 3,5 yaşında ve doğduğundan beridir uykuda terleme problemi var, herşeyi denedim ama sonuç alamadım. Bu yastıktan çok beklentim yoktu ama şans vermk istedim ve üretenlere hergün dua ediyorum. çok teşekkürler. başlarda tesadüf sandım ama sıcakta, soğukta, duş sonrası yüm gece kesinlikle terleme yok. indirimlerini takip ediyorum sırayla kendime eşime ve küçük oğlumada alıcam bu markanın yastıklarından. tekrar çok teşekkürler",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "A** T**",
  title: "Tavsiye üzerine aldık",
  comment: "Ürünü birmimarbirbebek Beste Hanımın tavsiyesi ile aldık çok beğendik teşekkür ederiz 🥰🥰",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "G** G**",
  title: "Çok rahat",
  comment: "Oğlum için almıştım epey oldu, çok rahat",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "**** ****",
  title: "Yumuşak ve kaliteli",
  comment: "Ecem Arda vesilesiyle aldım bayıldım. Yumuşaklığı,kalitesi inanılmaz.",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "P** K**",
  title: "Rahatlığına inanamadım",
  comment: "boyun düzleşmesi ve boyun fıtığım var, yüzüstü şekilde yatıyorum sadece ve çok uzun zamandır yastık arayışındaydım. rahatlığına inanamadım, bu kadar hızlı uykuya daldığıma hâlâ inanamıyorum bu kadar farketmesini hiç beklemiyordum açıkçası. çantalı şekilde geldi, seneye kızım için de yine aynı yastığı tercih edeceğim.",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "M** B**",
  title: "Müşteri hizmetleri harika",
  comment: "Bu boyutta çocuk yastığı bir türlü bulamıyordum, bulduklarım da yetişkin yastığından kalınlık olarak farksız oluyordu. Sonunda bu yastığı buldum ve aldım, iyi ki de almışım. Yastık tam istediğim büyüklük ve kalınlıkta, malzemesi kaliteli, içine koyup gönderdikleri çanta bile ayrı bir artı puan. Ayrıca müşteri hizmetleri mükemmel çalışıyor, kendi hatam sonucu yaşadığım bir problemle ilgili olarak inanılmaz yardımcı oldular ve hemen yeni iç dolgu gönderdiler. Türkiye'de maalesef pek rastlamadığımız bir durum olduğundan şaşırttı ve sevindirdi; bu yüzden özel olarak yorum yazmak istedim. Kendilerine tekrar teşekkür ederim.",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "M** A**",
  title: "Uyku kalitesi arttı",
  comment: "Bir gecede fark eder mi… bariz uyku kalitesi artı.. düşünmeden alın aldırın 🌸 çocuğum resmen rahat nefes alarak uyuyor. Çok şükür 🙏🏻 ef saaaaaa ne 🥳",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "e** ö**",
  title: "Bizim için ince kaldı",
  comment: "Ürün kalitesi ile ilgili birsey yazamam kullanmadım 7 yasındaki oğlum için almıştım çok ince bir yastık bize göre değil o yüzden iade ettik ama paketi kılıfı çok iyi düşünülmüş👍🏻",
  product: "Slothy Visco Kids Yastık",
  star: 3,
  image: true,
  video: "",
  poster: ""
},
{
  name: "İ** T**",
  title: "Mükemmel",
  comment: "Oğlum için aldım mükemmel",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "merve y.",
  title: "Rahat ve uyumlu",
  comment: "birmimarbirbebek Beste Hanımın önerisi ile kızıma aldım. Gerçekten yastık çok rahat yetişkinlerde tercih edebiliyormuş kendimede almayı düşünüyorum. Üstelikte ayrıca kılıf almak zorunda kalmadım evdeki standart kılıflar uydu.",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "e** o**",
  title: "İnanılmaz güzel",
  comment: "İnanılmaz güzel bir yastık! Severek kullanıcaz .. Çantasına da bayıldım 😍 Ayrıca hızlı kargo için teşekkürler 🙏🏼",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "B** S**",
  title: "Serin ve ideal",
  comment: "çok beğendim. serin bir hissi var. Boyutları ideal. 2,5 yaş için belki biraz yüksek. ilerde daha iyi olacaktır. kendi harika çantası ile birlikte geliyor.",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "A** T**",
  title: "Kızım çok rahat etti",
  comment: "2,5 yaşında buna geçtik kızım çok rahat etti gayet başarılı bir ürün",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "T** K**",
  title: "Hızlı ve kaliteli",
  comment: "Hızlı elime ulaştı ve çok güzel bir çantada geldi. Üzerindeki kumaş inanılmaz kaliteli çıkıp yıkanabilir olması güzel. Yüksekliği çok ideal. Yetişkin için olanı da kendime alacağım.",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "E** Ç**",
  title: "Yüksekliği ideal",
  comment: "2 yaşındaki kızım için aldım, yüksekliği ideal",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "S** M**",
  title: "Paketleme özenli",
  comment: "Gercekten cok guzel. Paketleme oldukca ozenliydi",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "Ş** D**",
  title: "Kızım rahat etti",
  comment: "Mükemmel kızım cok rahat etti gonul rahatlıyla alınır",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "K** U**",
  title: "Kaliteli ve kullanışlı",
  comment: "3 yaşında oğlum için satın aldım gerçekten çok kaliteli ve harika bir çanta içerisinde geliyor. Teşekkürler",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "S** O** K**",
  title: "Harika rahat",
  comment: "Harika rahat güzel",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "Z** F**",
  title: "Konforlu ve ideal boyut",
  comment: "Ebat ve konfor olarak çok iyi bir yastık 2,5 yaşındaki oğluma bilhassa bu boy aldım diğerleri çok küçük kalıyor çünkü ebat olarak iyi olup yükseklik açısından tam çocuklar için düşünülmüş",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "**** ****",
  title: "Oğlum rahat etti",
  comment: "Çok güzel ve rahat. oğlum çok rahat etti.",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "ö** b**",
  title: "Alerjik çocuklar için ideal",
  comment: "kizlarim alerjik ama aldigimdan beri asla gece öksürmüyolar😍",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "S** A**",
  title: "Beşik için ideal",
  comment: "Gün geçtikçe fiyatı artan guzel yastığımız. Beşiğimize tam oldu ölçüleri, kızım 2 yaşında bu yastıkl başladık yastık kullanmaya.",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "Ö** K**",
  title: "Uykusu düzeldi",
  comment: "2 yaşındaki kızımın uyanma sıklığı azaldı gerçekten rahat uyuyor tavsiye ediyorum",
  product: "Slothy Visco Kids Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "Ö** K**",
  title: "Herkese aldım",
  comment: "o kadar memnun kaldım ki 1 tane eşime 1 tane anneme aldım",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "Z** D**",
  title: "Boyun ağrılarına iyi geldi",
  comment: "Harika! Yaklaşık 1-1,5 aydır kullanıyorum. O kadar memnunum ki. Boyun ağrılarıma çok iyi geldi. Artık deliksiz uyku çekebiliyorum. Yüz üstü ve yan uyuyan biri olarak çok rahat ettim. Keşke elimde olsa 10 yıldız verebilsem.🫶🏻",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "D** b** O**",
  title: "Rahatlatıcı",
  comment: "Annem için aldım insanı rahatlatıyor alın derim",
  product: "Slothy Visco Ortopedik Yastık",
  star: 4,
  image: true,
  video: "",
  poster: ""
},
{
  name: "B** D**",
  title: "Konforlu ve rahat",
  comment: "Çok konforlu çok beğendim boyun ağrılarına birebir",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "M** C**",
  title: "Anneme aldım",
  comment: "Annem için aldım çok memnun kaldı",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "M** K**",
  title: "Ailecek memnunuz",
  comment: "Önce 2.5 yaşında oğlum için almıştım bebek yastığı olan ürünü sonra onu beğenince kendime aldım. Eşim de bir bakayım dedi ve geri vermedi. Şimdi bir tane daha sipariş vereceğim. Yataşın yastıklarını kullanıyordum öncesinde. İyi ki almışım, çok rahat tavsiye ediyorum alın aldırın.",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "I** A**",
  title: "Boyun ağrılarıma çözüm",
  comment: "Yorumlara ve satıcının samimi cevaplarına inanarak satın aldım. Gerçekten rahat bir uyku çektiğimi söylemeliyim. İlk başta biraz sert geldi ama sonrasında çok rahat ettim. Koku falan yoktu, kendi yastık kılıfımla rahatça uyudum.",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "A** D**",
  title: "Çok rahat",
  comment: "Çok rahat ve güzel",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "M** G**",
  title: "Keşke önceden alsaydım",
  comment: "Harika bir yastık, iyi ki almışım. Keşke çok önceden alsaydım",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "YAVUZ T.",
  title: "Kaliteli kumaş, terletmiyor",
  comment: "İnanılmaz kullanışlı ve şık bir çanta içinde geldi. Diğer viscolarda terleme sorunu yaşıyordum ama bunun kumaşı çok kaliteli. Sertlik derecesi bana çok uygun geldi, orta sertlikte. Çok memnun kaldım.",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "M** Ş**",
  title: "Boyun ağrılarım kayboldu",
  comment: "Ürün hızlı ve özenle hazırlanmış bir şekilde elime ulaştı. Boyun ağrısı çeken biri olarak bu yastıkla uyumak çok iyi geldi. Sloth Bedding yeni favorim. Şimdi yorganını deneyeceğim.",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "Ş** E**",
  title: "Neden geç aldık bilmiyorum",
  comment: "Neden bu kadar geç aldık bilmiyorum, o kadar rahat ki",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "İ** G** A**",
  title: "Yan yatışta bile konforlu",
  comment: "Omurgamda ciddi problemler var ama bu yastık çok iyi destekliyor. Yan yatışta yüksek yastık seviyorum, belki başka modeli denerim. Ağrılar yaşamamak için kesinlikle alınmalı.",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "Meltem S. A.",
  title: "Kargo hızlı, ürün harika",
  comment: "Çok hızlı geldi öncelikle teşekkür ederim kargo çok iyi paketlenmiş. Çantası da çok güzel. Kullanınca tekrar değerlendirme eklerim ama eminim yastık süper 🤩",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "Gülsima T.",
  title: "Boyun ağrılarım geçti",
  comment: "Boyun ağrılarım geçti, uyku kalitem arttı. Oğlum renkli çanta istediği için firma yetkilileri göndermiş. Çok naziksiniz, çok teşekkürler.",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "M** a**",
  title: "İyi",
  comment: "İyi",
  product: "Slothy Visco Ortopedik Yastık",
  star: 4,
  image: false,
  video: "",
  poster: ""
},
{
  name: "C** T**",
  title: "Rahat ettim",
  comment: "Rahat ettim",
  product: "Slothy Visco Ortopedik Yastık",
  star: 4,
  image: true,
  video: "",
  poster: ""
},
{
  name: "B** T** A**",
  title: "Boyun ağrılarım geçti",
  comment: "Kasım 2023’ten beri eşim ve ben kullanıyoruz, çok memnunuz. Ara sıra boyun ağrısı ile uyanıyordum, bu yastığı kullandığımdan beri hiç yaşamadım. Boyutu, yüksekliği her şeyi ile ideal 👌🏻",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "**** ****",
  title: "Yumuşacık",
  comment: "Çok güzel, yumuşacık",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "M** A**",
  title: "Rahat ama iyileşme süreci bekliyorum",
  comment: "Yatması güzel, henüz boyun ağrım geçmedi ama şimdilik rahat gibi",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "e** e**",
  title: "Memnun kaldım",
  comment: "Daha önce yataşınkini kullanıyordum, boyun fıtığım var, gayet memnun kaldım. Çantası da çok tatlıymış.",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "A** İ**",
  title: "Boyun ağrılarıma iyi geldi",
  comment: "Boyun ağrılarıma çok iyi geliyor",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "H** D**",
  title: "Fiyatını hak ediyor",
  comment: "Tereddütsüz boyun ağrısı çekenlerin tercih etmesi gereken bir uyku yastığı. Yastık, bence en az yatak kadar önemli ve özenle seçilmeli. Fiyatı biraz pahalı gelse de, birkaç gece kullanımdan sonra bu fiyata bu yastık kesinlikle doğru bir tercih. Bütçenize uyuyorsa tercih edebilirsiniz.",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "K** Ş**",
  title: "Doğru tercih",
  comment: "Ortopedik bir uyku yastığına çok ihtiyacım vardı, 3 marka arasında kararsız kaldım ama doğru bir tercih yaptığımı kullandıkça emin oldum. Teşekkür ederim.",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "Ş** K** U**",
  title: "Parasını hak ediyor",
  comment: "Çok güzel, parasını hakkediyor",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "İ** U** T**",
  title: "Kalite farkını hissediyorsunuz",
  comment: "Boyun düzleşmem ve boyun fıtığım var. Çok fazla yastık denedim :) Bu ürünün kalitesini paketinden itibaren hissediyorsunuz. Çantasından kumaşının dokusuna ve sertlik derecesine kadar diğer yastıklardan farklı. Kılıfının çıkıp yıkanabilmesi çok iyi. Visco kanallı ve hava sirkülasyonunu fark ediyorsunuz. Gönül rahatlığıyla tercih edilebilir.",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "Onur D.",
  title: "Kalite güzel ama sert",
  comment: "Başta biraz alçak gelmişti ama alıştım. Kalitesi güzel ama zamanla biraz sertleşti. Yastıkta yumuşaklık arayanlar hayal kırıklığı yaşayabilir ama muhtemelen böylesi daha sağlıklı.",
  product: "Slothy Visco Ortopedik Yastık",
  star: 4,
  image: true,
  video: "",
  poster: ""
},
{
  name: "Ç** Ş**",
  title: "Fiyatını hak ediyor",
  comment: "Ürün görseldeki gibi çok tatlı çantasıyla geldi. Boyun düzleşmem var, ağrılarım oluyor, umarım iyi gelir. Kumaşı ve dokusu iyi gibi ama denemeden bir şey yazamıyorum. Terletmezse sevinirim, fiyatını hak eden bir üründür umarım.",
  product: "Slothy Visco Ortopedik Yastık",
  star: 4,
  image: false,
  video: "",
  poster: ""
},
{
  name: "S** K**",
  title: "Güzel ürün",
  comment: "Ben ürünü iade etmek durumunda kaldım ama güzel ürün",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "M** a**",
  title: "Yumuşaklık problemi",
  comment: "Çok yumuşak. Başım yastığa gömülüyor. Aradığım yastık bu değilmiş. Edit: Firma bana daha yüksek ve sert hissiyatı olan lateks yastık gönderdi. Birkaç gündür lateks yastığı kullanıyorum, çok memnunum. Boyun ağrısı olan birisiyim. Yumuşak yastık isteyen yine de bu visco yastığı tercih edebilir. Müşteri memnuniyeti odaklı bir firma.",
  product: "Slothy Visco Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "M** B**",
  title: "Rahat ve hızlı teslimat",
  comment: "Çok rahat ettim, firmaya teşekkür ederim. Çok özenli ve hızlı bir şekilde kargomu teslim aldım. Herkese tavsiye ederim.",
  product: "Slothy Latex Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "H** D**",
  title: "Ortopedik ve Hipoalerjenik",
  comment: "Ortopedik ve hipoalerjenik bir yastık olması almak için ilk tercihimdi. Yüksekliği de gayet tatmin edici. Firmaya güzel paket ve hızlı kargo için de teşekkür ediyorum. Satın almak isteyenler rahat bir uyku için ortalama 14-15 cm yüksek ve ortopedik bir yastık kullanmak istiyorlarsa tereddüt etmeden tercih edebilirler.",
  product: "Slothy Latex Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "C** A** P**",
  title: "Yaşam kalitem arttı",
  comment: "Çok fazla boyun ağrım vardı ve sabahları ağrılarla uyanıyordum. Ama bu yastıkla yaşam kalitem arttı resmen. Kargo da hızlıydı. Ayrıca yastığın içinde bulunduğu çanta da çok şık ve kullanışlı. Teşekkürler.",
  product: "Slothy Latex Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "zehra a.",
  title: "Alerji karşıtı",
  comment: "Kılıfının dokusunun güzelliğine inanamazsınız. Eşimin alerjik bir yapısı var, onun için aldım. Ürünün hem lateks yapısı hem kılıfı alerji karşıtı, bu diğer markalardan farklı bir özellik. Orta yumuşaklıkta, orta kalınlıkta. Çantası çok hoş. Uzun süreli kullanım sonrasında yorumu güncellerim inşallah.",
  product: "Slothy Latex Ortopedik Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "M** K**",
  title: "Rahat yastık",
  comment: "Çok rahat bir yastık. Teşekkür ederim.",
  product: "Slothy Latex Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "R** A**",
  title: "Boyun ağrılarım azaldı",
  comment: "Yaklaşık bir aydır kullanıyorum, uzun süreli boyun ağrılarım vardı, son günlerde hissedilir derecede azalmaya başladı. Teşekkürler.",
  product: "Slothy Latex Ortopedik Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "S** H**",
  title: "Sorunsuz ürün",
  comment: "Çok güzel, sorunsuz geldi. Teşekkür ederim.",
  product: "Slothy Latex Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "s** ş**",
  title: "Heyecanlı bekleyiş",
  comment: "Aylardır beklediğim yastıkları, günler sonra anlık bir indirimle daha hesaplı aldım 🙏 Çok heyecanlı 😄 Paketleme ve kargo hızı efsane. Ürünün kullanımından sonra güncelleyeceğim yorumumu. Bu bence en heyecanlı kısmı… Yastık ararken bir yoruma rastlamıştım. Hayatta iki şeyden gülmedim, biri koca, biri yastık diye 😂 Ben de öyle. Ama umarım yastıktan memnun kalırım. Ben memnun kalırsam reklam da yaparım 😇 Görüşmek üzere 👋 Yaklaşık bir aydır kullanıyoruz yastıklarımızı, akşam olsa da yatsam modundayım 👍🏻🙏 Yok böyle bir rahatlık. Kendinize değer verin, ihtiyaçlarınız listenize alın. Çünkü eminim bu değilse, yastığınız ihtiyacınız olan bu… Tekrar teşekkür ederim satıcıya, alanlarda sağlıkla kullansın 🤍😇 Mışıl mışıl uyuyun 🫠",
  product: "Slothy Latex Ortopedik Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "M** M** U**",
  title: "Kullanışlı ve güzel",
  comment: "Günümüzün 3'te 1'ini harcadığımız bu ihtiyacımız için bence gayet güzel ve kullanışlı. Yaklaşık 6 aydır kullanıyorum, memnunum. Sertlik olarak orta yumuşak denilebilir.",
  product: "Slothy Latex Ortopedik Yastık",
  star: 5,
  image: true,
  video: "",
  poster: ""
},
{
  name: "O** B**",
  title: "Ergonomik destek",
  comment: "Ürün hemen gönderildi ancak MNG kargoda personel sıkıntısından dolayı 2 gün teslim edilmedi, gidip kendim aldım. Daha önce visco yastık kullanıyordum, şimdi lateks yastığa geçtim. Boyutu viscodan ve evdeki diğer elyaf ve benzeri yastıklardan küçük ama yeterli. 46 yaşındayım, çocukluğumda pamuk yastıklar vardı, boynu desteklerdi ama ergonomik değillerdi. Bu yastık boynu destekliyor ve kafanız içine çok gömülmüyor. Yastık çok sert değil ama çok rahat. Kılıfı çok kaliteli. Lateks hava alması için içinde kanallar var. %100 doğal ürünler biraz yüksek fiyatlı olmakta. %100 doğal olmayanların fiyatları daha ekonomik oluyor. Yastıkta hafif bir lateksten kaynaklı koku var ama beni rahatsız etmedi. Ben aldığım için memnunum, en azından 1 gecelik deneyim beni tatmin etti.",
  product: "Slothy Latex Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "K** Ş**",
  title: "Çok rahat",
  comment: "Çok rahat...",
  product: "Slothy Latex Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
{
  name: "B** C**",
  title: "İdeal yükseklik",
  comment: "Yüksekliği ideal, çok rahat bir yastık. Tek problemi, yastıkta bir koku var. Beni rahatsız etmedi ama kokulara karşı hassas olanlar dikkate almalı.",
  product: "Slothy Latex Ortopedik Yastık",
  star: 4,
  image: false,
  video: "",
  poster: ""
},
{
  name: "E** B** A**",
  title: "Kronik boyun ağrıları için mükemmel",
  comment: "Almadan önce çok araştırdım. İnsanların bu fiyata yatak var sözlerini bir kenara atın. Eğer kronik boyun ağrınız varsa, benimkine inanılmaz iyi geldi. Çok kaliteli ve keyifli bir yastık.",
  product: "Slothy Latex Ortopedik Yastık",
  star: 5,
  image: false,
  video: "",
  poster: ""
},
    {
        name: "f** d**",
        title: "Yastık çok düşük",
        comment: "alcak yastik",
        product: "Slothy Latex Ortopedik Yastık",
        star: 1,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "S** K**",
        title: "Hızlı teslimat ve konfor",
        comment: "İnanılmaz hızlı akşam aldım sabah elimdeydi ve paketlenmesi çantalı olması çok güzel 👍🏽 henüz yeni kullanmaya başladım ama rahat kullanımı diyebilirim yumuşaklığı orta ne çok sert ne de çok yumuşak. Boyun sıkıntıları olanlar için iyi diyebilirim",
        product: "Slothy Latex Ortopedik Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "A** K**",
        title: "Baş ağrılarınız için mükemmel",
        comment: "Baş ağrısından kurtulun",
        product: "Slothy Latex Ortopedik Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "M** A**",
        title: "Harika kalite",
        comment: "super kalite cok begendik",
        product: "Slothy Latex Ortopedik Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "Y** K**",
        title: "Rahatlık",
        comment: "evet hafif bi koku var fakat boynuma çok iyi grlfi",
        product: "Slothy Latex Ortopedik Yastık",
        star: 4,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "m** a**",
        title: "Mükemmel doku",
        comment: "Dokusu harika. Kafanız yastığa gömülmesin istiyorsanız aradığınız ürün kesinlikle bu. Başı hiç rahatsız etmeyecek şekilde geri itiyor gibi. Boyun ağrımı da azalttı. Sadece bu ücreti verdiğiniz bir yastıkta bu dikişi görmek üzüyor. Teşekkürler.",
        product: "Slothy Latex Ortopedik Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "Ş** K** U**",
        title: "Boyun ve fıtık sorunları için ideal",
        comment: "Boyun düzleşmem ve fıtığım için ve çok memnunum",
        product: "Slothy Latex Ortopedik Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "o** m**",
        title: "Boyun fıtığı için en iyi yastık",
        comment: "boyun fitigindan sonra uyuduğum tek yastikbi cok yastik denedim keske daha önce alsaydım",
        product: "Slothy Latex Ortopedik Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "Seda Y.",
        title: "Hayal kırıklığı",
        comment: "Ürün vadettiği rahatlığı sağlamıyor bence. Kullandıkça yüksekliği azalıyor ve yastık sönüyor. Uyurken insanın kafası yastığa gömülüyor. Bu şikayetimi markaya ilettiğimde oldukça ilgili davrandılar ve yeni yastık gönderdiler ama onda da durum değişmedi maalesef. Bu yastığı boynunuza iyi geleceğini düşünerek satın alırsanız hayal kırıklığına uğrayabilirsiniz.",
        product: "Slothy Latex Ortopedik Yastık",
        star: 2,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "H** S**",
        title: "Ideal yükseklik ve rahatlık",
        comment: "kılıf pamuklu terletmiyor.yükseklik az değil, ideal. basılma olmuyor.horlamayı ve terlemeyi azalttı.latex yastık ararken piyasada bu özellikleri taşıyan en uygun fiyatlısı.başka marka bakarsanız kılıfın polyester olmamasına dikkat edin.",
        product: "Slothy Latex Ortopedik Yastık",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "**** ****",
        title: "Rahatsız edici bir koku",
        comment: "Rahatsız edici bir kokusu var.",
        product: "Slothy Latex Ortopedik Yastık",
        star: 2,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "A** U**",
        title: "Uygun gelmedi",
        comment: "9-23 Nisan aralığında kullandım fakat alışamadım bir türlü. Ne ağrılarıma iyi geldi ne de uyku kaliteme pozitif bir etkisi oldu. Aksine gece boyu devamlı uyanıyorum.",
        product: "Slothy Latex Ortopedik Yastık",
        star: 3,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "**** ****",
        title: "Alçak yastık",
        comment: "Satici cok ozenli ve hizli. Annem icin almistim bu cok alcak bebek yastigi gibi dedi. Yan yatanlar icin uygun olmadigini dusunuyorum iade edecegim.",
        product: "Slothy Latex Ortopedik Yastık",
        star: 4,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "A** A**",
        title: "Harika ürün",
        comment: "@ecemarda tavsiyesiyle aldığım yine harika bir ürün daha. Paketleme harika ürün dokusu kalitesi muhteşem güvenerek alabilirsiniz. 17 aylık bebeğim için doktor onayından sonra aldım",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "İ** A** B**",
        title: "Bambu kalitesi",
        comment: "Bambu olduğu için tercih ettim, bakteri önlüyor.Paketlemesi güzeldi, çanta içinde geldi.Çok memnunum.Başka arayıp vakit kaybetmeyin derim",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "yasemin G.",
        title: "Yeterli ve özenli",
        comment: "Yastık çok güzel 2 yaşındaki kızım için aldım gayet yeterli, çok özenli bir kılıf ile geldi yetişkin yastığını da alacağım @ecemarda tavsiyesi ile aldım",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "T** Y**",
        title: "Güzel paketleme",
        comment: "Güzel paketlenmiş, çok beğendik.",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "Demet D.",
        title: "Güvenilir ve kaliteli",
        comment: "guvenle kullaniyorum urubun paketlemeesi cok iyiydi",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "B** Ç**",
        title: "Parasını hakeden",
        comment: "Çok güzel, çok rahat bir yastık. Ayrıca paketlemesi ve kargolanma hızı da çok iyiydi. Başka bir yastık aramaya gerek yok. Parasını hakeden bir marka.",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "**** ****",
        title: "Yumuşak ve özel paketleme",
        comment: "Paketlemesi çok çok iyiydi özel bir kılıfla geliyor. Yumuşak bir yastık",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "c** ö**",
        title: "Fiyat performans ürünü",
        comment: "Özenli paketlemişler kullanma fırsatım oldu kalitesi de güzel ürün. Fiyat performans diyebilirim ürün için daha önce aldığım ürünlerde pahalı ve kalitesiz çıkmıştı bu ürün beklediğimden iyi çıktı",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "H** D**",
        title: "Terletmeyen yastık",
        comment: "kızım için aldım. henüz çok fazla kullanma imkanım olmadı ancak 1-2 gece kullanım sonrası yorumum kesinlikle çok rahat ve terletmediği yönünde. kızım geceleri çok terler ve baş kısmı özellikle sabaha karşı su içinde kalır. bu yastıkta o olmadı. daha ilerleyen zamanlarda uzun dönem kullanım yapıp daha detaylı yorum yapmak isterim",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "Y** Y**",
        title: "Kusursuz dokuma",
        comment: "Yıkadım bozulmadı üstelik paketleme ve dokusu da harika!",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "m** y**",
        title: "Kaliteli ve özenli",
        comment: "henüz kullanma fırsatım olmadı ama kalitesi paketinden ambalajından belli oluyor. kargo çok özenliydi ve hızlı bir şekilde tarafıma ulaştı. satıcıya teşekkür ederim, kullandıktan sonra yorumlarımı ileteceğim",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "seda Y**e.",
        title: "Güzel paketleme",
        comment: "Ürün çok güzel paketlenerek , kılıfıyla elime ulaştı , teşekkürler",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "G** A**",
        title: "Güzel ve kaliteli",
        comment: "Güzel kaliteli bir yastık makineye atıyorum hiçbir şey olmuyor güzel kuruyor",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "A** M**",
        title: "Tatlı paketleme",
        comment: "Çok tatli bir paketleme ile geldi, henüz denemedik ama sanırım doğru tercih oldu - thanks to burcu kuru 🫶🏼",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "N** A** T**",
        title: "Rahat ve kaliteli",
        comment: "çok rahat ve kaliteli bir ürün",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "b** g**",
        title: "İdeal yaş",
        comment: "Çok güzel 2 yaş için ideal",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "T** K**",
        title: "Özel çanta",
        comment: "Çok güzel , özel çantasında geliyor.",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "S** A**",
        title: "Hızlı ve kullanışlı",
        comment: "Hızlı geldi kaliteli. Çantası çok kullanışlı",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "T** E**",
        title: "Özenli paketleme",
        comment: "Ürün özenli paketiyle geldi kılıfı da çok hoş ayrıca her ne kadar biraz değişik koksa da… 2 yaşında oğlum için aldım umarım terletmez. Yorumlara güvenerek aldım.",
        product: "Slothy Bamboo Bebek Yastık",
        star: 4,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "G** G**",
        title: "Güzel ve rahat",
        comment: "Çok guzel ve cok rahat",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "M** Ç** B**",
        title: "Paketleme ve çanta",
        comment: "Çok güzel pketleme ve çantasıyla geldi",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "e** ç**",
        title: "Küçük ama yeterli",
        comment: "Kılıfıyla geldi çok güzel beklediğimden biraz küçükmüş ama 2 yasinda oğlum yeterli oldu",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "d** y** ş**",
        title: "İyi boyut ve yumuşaklık",
        comment: "boyutu yuksekliği yumuşaklığı gayet iyi",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "e** g**",
        title: "Çocuk memnuniyeti",
        comment: "Aldığım üründen memnun kaldım aslında en önemlisi benim çocuğumun beğenmesi oldu. Özellikle dokunduğun zaman verdiği his çok hoşuma gitti",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "a** s**",
        title: "Bakteri önleyici",
        comment: "ben çok beğendim. bakteri önleyici özelliğinin olması ilk tercihimdi. ölçüleri ideal görünüyor. benzeri yastığın daha büyük varyasyonları olmasını dilerdim",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "S** S**",
        title: "Yüksek ama sevdi",
        comment: "Biraz yüksek ama iki yaşındaki kızım ilk aldığım günden beri Sevdi ve onunla uyuyor",
        product: "Slothy Bamboo Bebek Yastık",
        star: 4,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "Z** S**",
        title: "Küçük ama güzel",
        comment: "2.5 yaşındaki oğlum için aldım güzel ürün ama biraz küçük geldi",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "A** S** K**",
        title: "Tavsiyeler",
        comment: "Tavsıye ederim cok begendım",
        product: "Slothy Bamboo Bebek Yastık",
        star: 4,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "M** Ö**",
        title: "harika bir yatak",
        comment: "2 yaş için ideal.",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "M** K**",
        title: "en iyi ürün",
        comment: "yastığın daha dikdörtgen bir boyutu varsa onu da almayı çok isterdim ancak yok sanırım. bebeğimiz için bulduğum en iyi ürün diyebilirim. yastık bir kere çok rahat ve içine gömülmüyor. başı yana da düşmüyor. ne çok yumuşak ne de çok sert. tam kararında bir yastık. bakteri önleyici özelliği konusunda bir fikrim yok onu nasıl anlayabilirim bilmiyorum fakat iyiki almışım dediğim nadir ürünlerden biridir..",
        product: "Slothy Bamboo Bebek Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "**** ****",
        title: "Mükemmel",
        comment: "Mükemmel paketlemesi kalitesi her şeyi. Parasına değer",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "A** F** S**",
        title: "100 yıldız",
        comment: "100 Yıldız olsa da versem bayıldım oğlum için aldık çok beğendik",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "B** B**",
        title: "Süperr",
        comment: "@annebebekdoktoru Gökçe Mat Hanımın tavsiyesi ile aldım. Kargo çok güzel korunaklı çantalı vakumlu şekilde geldi. Kargoyu açmadan yatağı aşırı ince sandım iade etmeyi düşündüm. Sonra 7 cm olduğunu sorulardan teyit edip açtım ve vakumun etkisi gidince gayet yeterli kalınlıkta bir yatak. İnşallah bebeğimi yatırmak nasip olur. Çok kaliteli belli",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "a** T**",
        title: "Özenli paketleme",
        comment: "Dokusu sertliği güzel, bebişimiz henüz doğmadığı için kullanımla ilgili bir şey diyemem. Paketleme çok özenli. Kendi çantasında vakumlu şekilde geliyor. Dış kılıfını çıkarıp yıkadım hiçbir sıkıntı olmadı.",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "F** Y**",
        title: "İlgili satıcı",
        comment: "Yeni doğan bebeğim için aldık, severek kullanıyoruz, yıkanabilir olması ayrıca harika. Satıcı olarak da benden kaynaklı bir yanlış anlamayı bile ürünlerinin arkasında durmaları sayesinde kısa sürede çözdük, teşekkür ediyorum hem ürün kalitesi için hem ilgileri için",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "A** H**",
        title: "Beğendim",
        comment: "Çok beğendim😍",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "H** Y**",
        title: "Pratik",
        comment: "Çok beğendim. Fermuarı tam açılıyor, çok pratik.",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "B** S**",
        title: "Bebeğim için en iyisi",
        comment: "110x60 ebatlı yatak chicco next2me forever park yatağa uyuyor. Sert değil. Yumuşaklığı iyi. Chicco’nun kendi şiltesine göre bebeğimi daha az terletti. Tek şikayetim ben aldıktan bir kaç gün sonra kupon ile %20 indirim yapıldı. Ben de şimdi gerçek fiyatını sorguluyorum.",
        product: "Slowbie Bebek Yatağı",
        star: 4,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "ALPER D.",
        title: "Memnuniyet",
        comment: "ürünü aldim ama.ben memnun kalamadim ortaya dogru.göcüyor yatak",
        product: "Slowbie Bebek Yatağı",
        star: 4,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "Oğuzhan Ş.",
        title: "Kaliteli",
        comment: "Ürün çok kaliteli, parasının hakkını kesinlikle veriyor 👍🏼",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "G** K**",
        title: "Kalite",
        comment: "Aşırı kalite aşırı güzellik",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "ö** h** a**",
        title: "Küçük geldi",
        comment: "Merhaba ölçüleri küçük geldi, 65/95 olarak özel üretim yapabilir miyiz?",
        product: "Slowbie Bebek Yatağı",
        star: 5,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "Ö** A** G**",
        title: "Beğendimm",
        comment: "beğendim kaliteli",
        product: "Slowbie Bebek Yatağı",
        star: 4,
        image: true,
        video: "",
        poster: ""
    },
    {
        name: "H** D**",
        title: "Rahat yastık",
        comment: "istanbulda yoğun nemli bir evde yaşıyorum. bir çok yastik çeşidini test eden biri olarak, çok ferah ve bir o kadar da rahat bir yastık. eğer kampanyaya girerse 4 adet daha almayı düşünüyorum. satıcıya da çok teşekkür ederim özenli paketleme ve hızlı teslimatından dolayı",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "Z** M**",
        title: "Mükemmel ürün",
        comment: "yastık konusunda çok titiz bir insan olarak, bu yastığı büyük bir titizlikle seçtiğime emin olabilirsiniz. 50x70 ölçüleri çok ideal ve yüzeyindeki yumuşak doku asla terletme yapmıyor , olduk.a keyifli bir uyku arkadaşı diyebilirim",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "m** e** g**",
        title: "Mutluluk",
        comment: "Çok yumuşaktı bunu alınca evdeki diğer yastıkları kenara attım :) Bir yastık bir insanı nasıl bu kadar mutlu eder :)",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "tayyip e. s.",
        title: "Güzel",
        comment: "Rahatına düşkün biri olarak beğendim. Bu kaliteye bozmadan devam ederler markanın yatağının da olduğunu gördüm yakın zamanda onu da alacağım inşallah kalitesi bu şekildedir.",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "sultan ç.",
        title: "Tatmin edici",
        comment: "Ürünün paketlemesi hoşuma gitti almadan önce markaya da bakmıştım gayet tatmin edici. Uykusuna benim gibi düşkün olan alabilir. Sadece biraz daha kampanya yapsalar güzel olur",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "n** k**",
        title: "Rahat uyku",
        comment: "Piskolojik mi bilmiyorum ama yastığı aldığımdan beri baya rahat uyku çekiyorum. Alırken fiyatına değer mi diye düşünüyordum şimdi diyorum iyi ki aldım diyorummmmmmmmmmm",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "s** a**",
        title: "Hoş ürün",
        comment: "Daha yeni paketini açma fırsatım oldu güzel paketlenmiş beğendim verdiği his ürünün hoş ürünü şimdi deneyimleme zamanı.",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "K** Ş**",
        title: "Tavsiye ederim",
        comment: "ısıyı dengeleyen bir yastık önce çok mantıklı gelmemişti ancak 1 haftadır kullanıyorum, kesinlikle parasını hak ediyor. tavsiye ederim.",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "melisa k.",
        title: "Teşekkürler",
        comment: "Çok terleyen biri olduğum için bu yastığı aldım gerçekten rahat uyuyabildim. Satıcısına çok teşekkürler.",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "E** D**",
        title: "Mükemmel",
        comment: "Çok başarılı",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "n** s**",
        title: "İyi ürün",
        comment: "Bunu kullanmak için kışı bekliyorum kışın beklediğim gibi çıkarsa evde herkese alacağım şuanlık gayet iyi ürün",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "k** v**",
        title: "Parasına değer ürün",
        comment: "Ürünü alırken pahalı olduğunu düşünüyordum ama ürünü aldıktan sonra parasına değdiğini gördüm. Güzel bir kampanya yaparlarsa tekrar almayı düşüyorum. Beklediğim gibi kaliteli çıktı",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "M** C**",
        title: "Kalite ve hoş doku",
        comment: "Kalitesini beğendim güzel ürün. Dokusu da hoş",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "ahmet s.",
        title: "Hızlı gönderim",
        comment: "Yumuşak ve içeriğinde yazdığı gibi ısıyı dengeliyor. Hızlı geldi.",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "tuncay k.",
        title: "Parasına değer",
        comment: "Fiyat olarak alırken yüksek gelmişti ama aldıktan sonra fikrimi değiştirdim parasına değer bir ürün 3 ay sonra tekrardan satın alacağım biraz daha ürünü test edeceğim umarım uzun zaman geçince de kalitesinden bir şey kaybetmez. Hızlı gönderim için teşekkürler.",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "O** O**",
        title: "Çok iyi yastık ama",
        comment: "çok iyi bir yastık ama yüksek yastık sevmeyenlere tavsiye etmem",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "M** K**",
        title: "Kurtarıcı",
        comment: "bu sıcaklarda bu yastık kurtarıcım oldu. kışın denemedim ama kışın da üşütmeyeceğini tahmin ediyorum. genelde yastık başımın altından kayar gider. ürün açıklamasında sabit tutan yastık yazdığı için tercih ettim. şu an yastık ile 4.cü günüm, henüz başımın altından kayıp gitmedi. çok da rahat. sevdim ;)",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "Pınar A.",
        title: "Çift Taraflı Kullanım",
        comment: "Boyun ağrım nedeniyle yastık arayışındaydım. Sosyal medyadan takip ettiğim damyskitchen yazın terleme yapmayan boyun için ideal güzel bir yastık paylaşımından sonra aklımdaydı. Yastığımı 1 haftadır kullanıyorum ve çok memnunum☺️Umarım uzun süre bu formu korur. Çift taraflı kullanımı mevcut. Almak isteyenlere tavsiye ediyorum.",
        product: "Slothy Cool Outlast Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "Fikret S.",
        title: "Mükemmel bir yastık",
        comment: "Mükemmel bir yastık paketleme özenli ve güzel",
        product: "Slothy Classy Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "Ş** Ç**",
        title: "Ürün çok güzel",
        comment: "Ürün çok güzel, rahat uyuyorsunuz. Ayrıca terleme de yapmıyor❤️",
        product: "Slothy Classy Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
        name: "e** ö**",
        title: "Güzell",
        comment: "Ürüne bayıldık yumuşacık",
        product: "Slothy Classy Yastık",
        star: 5,
        image: false,
        video: "",
        poster: ""
    },
    {
    name: "Ayşegül Eryaşar",
    title: "Sağlık İçin Doğru Seçim",
    comment: "Merhaba, eşimin bel rahatsızlığı vardı. Yeni bir yatak arayışına girdik. Tesadüfen Sloth Bedding ile tanıştık. Bu yatağın kişiye özel tasarım olması ve ozanla temizlenmesi bizi etkiledi. 2 aydır kullanıyoruz. Çok rahat ve etkisi güzel, tavsiye ederiz.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/313063d5a1774b5c93699e91cad91f18.mp4",
    poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/Screenshot_2.jpg?v=1734012720"
},
{
    name: "Arzu Y.",
    title: "Doğal ve Sertifikalı Lateks",
    comment: "LATEKS BİR YATAK ARIYORDUK BİRÇOK YERDE VAR AMA SLOTH BEDDING SERTİFİKALI VE DOĞAL LATEKS OLARAK SATIŞ YAPIYOR. VE ÇOK GÜZEL BİLGİLENDİRİYOR UMARIZ HERKES BU YATAKLA TANIŞIR. BİZ NASIL ANLATALIM Kİ, KISACA AŞIRI MEMNUNUZ.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Burak B.",
    title: "Bel Fıtığı İçin Rahat Çözüm",
    comment: "İşim sebebi ile bel fıtığım var ve birçok yatak denedim ama hiçbirinde rahat edemedim. Uzun araştırmalarım sonucunda Sloth Bedding ile tanıştım ve ofislerine gittim. Uzman bayan çok yardımcı oldu. İçime sindi, denemek istedim. Şu an çok memnunum. Rahat uyku uyuyorum ve sağlığım için en iyisi bu sanırım. Türk firması ve bütün ürünleri patentli.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Buse N.",
    title: "Rahat Uyku Tavsiyesi",
    comment: "Bir arkadaş tavsiyesi üzerine aldık, ilk yatağımızı Sloth Bedding'den seçtik. Çünkü yorumları çok iyiydi, memnuniyet çok fazla. Yatakla ilgili güzel yönlendirme yapıyorlar. Teslimat yapılırken de yardımcı oldular. Biz memnunuz. Rahat uyumak isteyen herkes denemeli bizce. Her şey için teşekkürler.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Erdem Y.",
    title: "Deliksiz Uyku Konforu",
    comment: "Herkese selam, biz tavsiye üzerine aldık. Aşırı rahat bir konforu var. Resmen deliksiz uyuduk, gece boyunca eşimin horlamasını duymadım bile :) Kesinlikle alın.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Filiz Bb.",
    title: "Temiz ve Sağlıklı Uyku",
    comment: "Eski yatağımızı değiştirmek istediğimizde birçok firma ile karşılaştım fakat en sonunda tercihimi Sloth'dan yana yaptım. 100 gün deneme süresi cazip geldi. Yatağın içindeki küf, mantar ve mite'lardan kurtulmak, temiz uyumak, kısaca hastalık riskinin azalması kesinlikle 'bu' dedirtti. Biz memnunuz, iyi ki aldık. Çevremizde herkese tavsiye ediyoruz.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Gizem Ş.",
    title: "Aile Boyu Memnuniyet",
    comment: "Biz oğlumuz için aldık. Kullandık ve memnunuz. Yastıklarını da aldık, bambu serisi çok rahat. Kendimiz de kullanıcıyız. Sloth Bedding'den çok memnunuz, her konuda çok iyiler.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Güler Can P.",
    title: "Mükemmel Hizmet ve Konfor",
    comment: "Biz araştırma yaparak bu firmayı bulduk. Ürünlerinin çok kaliteli olmaları ve her zaman en iyi şekilde sunulmaları biz çok etkiledi. Arıyorsunuz, her şeyi soruyorlar. Mükemmel ötesi bir firma ve yataklar. Ben ve eşim çok rahat ettik. Komşumuzda almayı düşünüyor, sürekli tavsiye de ediyoruz. Rahatlık ve güzel uyku.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Gülizar Öztürk",
    title: "Temizlenebilir Yatak Farkı",
    comment: "Sloth Bedding yatağımızı 3 aydır kullanıyoruz. Temizlenebilen yatak olması, bize göre diğer yataklardan ayırt edici bir özellik oldu. Çok severek kullanıyoruz. Kesinlikle şans verilmeli, teşekkürler.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/12b80a4ca983476d81e6902177574729.mp4",
    poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/Screenshot_1.jpg?v=1734012781"
},
{
    name: "Hacer",
    title: "Instagram Tavsiyesiyle Mükemmel Yatak",
    comment: "Instagram'da görüp aldığımız yatak için Sloth Bedding ailesine teşekkür ediyoruz. Aradığınız her şey var bu yatakta. Bizce arayın ve konuşun, size güzel bilgi veriyorlar. Rahat etmeniz için her şeyi yapıyorlar. Tavsiyedir.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Hülya",
    title: "Yeni Başlangıç, Keyifli Uyku",
    comment: "Yatak değişimi vakti gelmişti ve yıllardır kullandığım yatağa elveda deyip daha modern bir yatak almak istedim. İlk reklamını görüp beğendiğim Sloth Bedding yataklar için firmayı aradım, konuştum, beni ikna ettiler. Konuştuğumuz uzman bayan çok yardımcı oldu ve Code Air Clean yatak aldık. Yıllarca hiç uyku uyumamış gibi keyifle uyudum. Tavsiye sebebimizdir.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "izel Ç.",
    title: "Kişiye Özel Konfor",
    comment: "Merhaba, harika bir paketleme ile gelen Sloth yatak kişiye özel yapılabiliyor. Ve uyuduğunuzda rahatlık veriyor, sanki hiç uykuyu hissetmiyorsunuz. Hava alan kılıfların yıkanabilir olması güzel. Temiz yatak hissini sevdik. Memnunuz.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Melike Can Yoldaş",
    title: "İlgili ve Sağlıklı Yatak",
    comment: "Bu firma çok ilgili ve ben hayran kaldım satış konusunda ki sohbetlerine. Biz oğlumuz için aldık, fazlaca memnunuz. Güzel, temiz, sağlıklı ve hava alan bir yatak.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Meral K.",
    title: "Büyülü Yatak Deneyimi",
    comment: "BİZ İNTERNETTE GÖRÜP SADECE MERAK ETTİĞİMİZ İÇİN BİR BAKALIM DEDİK. KENDİMİZİ BU BÜYÜLÜ YATAKLARLA AŞK YAŞARKEN BULDUK))) AŞIRI RAHAT, VAZGEÇMEK MÜMKÜN OLMUYOR, ALIŞINCA KESİNLİKLE TANIŞIN DERİZ.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Meryem",
    title: "Komşu Tavsiyesiyle Rahat Yatak",
    comment: "Bir komşu tavsiyesiyle aldım. Ben de herkese tavsiye ederim. Temiz yatak ve çok rahat.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},{
    name: "Muhammet H.",
    title: "Romatizma İçin İdeal Yatak",
    comment: "Ağır bir romatizma hastasıyım. Bu firmayı internette gördüm ve yatakları araştırdım. Doktorum, çok sert olmayan, çok yumuşak da olmayan bir yatakta yatmam gerektiğini söyledi. Ben de öyle yaptım, bana özel bir yatak üretimi yapıldı. Birçok kez arandım ve ağrılarım azaldı. İnanın şaka demiyorum, ağrılarım azaldı. Size de tavsiye ederim.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Murat H.",
    title: "Doğal Lateks Yatak Deneyimi",
    comment: "MERHABA, BİZ EŞİMLE LATEKS YATAK ALMAK İSTİYORDUK. ARAŞTIRMALARIMIZ SONUCUNDA EN DOĞAL LATEKSİN SLOTH BEDDİNDE OLDUGUNU ÖĞRENDİK. VE GİTTİK, GÖRDÜK, DENEDİK. BİZE GEREKLİ BÜTÜN BİLGİLER VERİLDİ. BAYILDIK, TABİKİDE ALDIK. HEYECANLA BEKLEDİK, SONUNDA GELDİ. ŞU ANA KADAR NERDE YATIYORMUŞUZ DEDİK. HARİKA BİR YATAK. RAHAT VE DERİN UYKU UYUYABİLİYORUZ, ŞİDDETLE TAVSİYE EDİYORUZ.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Mustafa B.",
    title: "Yaşlılıkta Rahat Uyku",
    comment: "Hayırlı günler olsun herkese. Yaşlandık, eşimle en güzel yatakta uyumak istedik. Herkes bize bu firmayı tavsiye etti. Biz de aradık, konuştuk, telefondan bile bize öyle güzel yardımcı oldular ki çok sevindik. Code yatak aldık. Orta sert önerdiler, çok yumuşak olmasın diye tembihlediler bir de. Rahatımız için uğraşan, dinleyen, yardımcı olan herkese teşekkür ederiz.",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Şilan Yaman",
    title: "Rahat ve Temiz Uyku Deneyimi",
    comment: "Uzun bir araştırma sonrasında Sloth Bedding'i tercih ettik. Kılıfların çıkarılıp yıkanabilir olması ve her sorunumuzda yanımızda olduklarını bildiğimiz sağlam bir ekip ile huzurlu, temiz, rahat bir uyku uyuyoruz. Sana kocaman teşekkürler Sloth Bedding.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "https://cdn.shopify.com/videos/c/o/v/c01124a5558c4384827660d802ae8f7b.mp4",
    poster: "https://cdn.shopify.com/s/files/1/0622/0680/4146/files/Screenshot_2_32ccf3d7-fd4d-4ec8-b82f-78731bb4c24e.jpg?v=1734012855"
},
{
    name: "Deniz K.",
    title: "Alerjik Çocuklar İçin Mükemmel Yatak",
    comment: "Merhabalar, biz oğlumuz için aldık, çok memnunuz, tavsiye ederiz. Alerjili bir çocuğunuz varsa, onun rahatı için en iyisini yapmışlar. Hep temiz yatakta uyuma hissi bile içinizin rahat etmesini sağlıyor.",
    product: "Future Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Emel S.",
    title: "Anne Olarak Sağlıklı Yatak Seçimi",
    comment: "BEN BİR ANNE OLARAK ÇOCUĞUMUN RAHAT UYKU UYMASI, RAHAT NEFES ALMASI, TOZSUZ TEMİZ BİR YATAKTA YATMASI İÇİN AYLARCA ARAŞTIRMA YAPTIM. BİLDİĞİNİZ BÜTÜN MARKALARI ARAYAN, BİLGİ ALAN BİR ANNE OLARAK TERCİHİMİ SLOHT BEDDİNG'DEN YANA YAPTIM. ÇÜNKÜ SERTİKALI ÜRÜNLER, DOĞAL LATEKS, TENE UYUMLU KILIFLAR, SÜREKLİ ARAYAN, SORAN ÜRÜNÜN HER TÜRLÜ KARŞISINDA DURAN BU FİRMAYI KEŞFETMEK GÜZELDİ. İYİKİ TANISTIK. TEŞEKKÜRLER.",
    product: "Future Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Esra H.",
    title: "Ozonla Temizlenen Yatak Deneyimi",
    comment: "ASLINDA HERŞEY ZATEN ONLAR İÇİN OLUNCA, EN RAHAT, EN GÜZEL, EN İÇİMİZE SİNEN YATAĞI BULMAK ÇOK ZOR OLMADI. SLOHT BEDDİNG ÖYLE BİR ÖZELLİK YARATMIŞ Kİ, ZATEN ALMAK İÇİN TEK SEBEP, YATAK OZONLA TEMİZLENEBİLİYOR. SÜREKLİ TEMİZ YATAKTA UYUDUĞUNU BİLMEK HERŞEYE DEĞER. BİZİM TAVSİYEMİZDİR. İYİ Kİ YATAĞINDA HUZURLA UYUMASI EN GÜZEL DUYGU. TEŞEKKÜRLER SLOHT BEDDİNG.",
    product: "Future Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Hakan T.",
    title: "Genç İçin Sağlıklı Yatak Seçimi",
    comment: "Merhabalar, artık genç olan oğlumuz için aldık. Uyuyunca odada oluşan sessizlik, doğru yatak aldığımızın işareti sanırım. Sürekli temizlendikçe yeni yatak olması bambaşka bir durum. Biz alırken alez kullanmayın, zaten kılıflar çıkarılıp yıkanabiliyor denildi. Yatak 360 derece yıkanabilen bir kılıfa sahip. Biz memnunuz, tavsiye ediyoruz.",
    product: "Future Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "irem F.",
    title: "İkizler İçin Sağlıklı Yatak Seçimi",
    comment: "Merhabalar, biz ikizlerimiz için aldık. Air Clean denen temizlik olayı bizim ilgimizi çekti, sağ olsunlar çok yardımcı oldular her konuda. Kilo, boy, yaş... Her şeyi soruyorlar. Eğer bir rahatsızlık varsa ona göre de yatak yapılabiliyormuş. Biz ailecek çok memnunuz. Uykuda rahat nefes almaları ve uyurken vücudu destekleyen yapıda olması bize yeterli geldi. Çocuklarımızın sağlıklı bir yatakta uyuması güzel bir duygu.",
    product: "Future Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "istanbul",
    title: "En Kaliteli Yatak Seçimi",
    comment: "Yakışıklı oğlumuz için en kaliteli yatak arayışındaydık. Sonunda sitede reklamlarını gördüm, baktım, anneler çok memnun, yorumlara baktım, inceledim. Sonra firmayı aradık, denemek istiyoruz dedik. Çok ama çok yardımcı oldular. 100 gün deneme süresi verildi. İyi ki aldık, teşekkürler Sloht Bedding.",
    product: "Future Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "izel",
    title: "Sağlıklı ve Konforlu Yatak Deneyimi",
    comment: "Kızımız için aldık, çok memnunuz. Oda rahat uyku uyuyor. En sağlıklı yatak bence, arada bizde kıvrılıyoruz, inanın harika bir keyif veriyor.)) Almak isteyen varsa, müşteri temsilcileri ya da uzmanlarla konuşup yataklar hakkında bilgi sahibi olabilirler. Biz uzman yardımı alarak karar verdik. Süreç güzeldi.",
    product: "Future Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Selma",
    title: "Doğal Lateks Yatak Memnuniyeti",
    comment: "2 aydır kullandığımız yatağımızdan öyle memnunuz ki yazmakla bitmez sanırım. Doğal lateks olan bu yatak için bir çok yorum okudum, hepsi de 10 puan vermiş. Verilen paraya değer bir yatak olmuş. Firma çok ilgili, zaten başarılarının devamını diliyorum. Air Clean teknolojisi kendi başına bir başarı. 100 puan… Tavsiye ederiz.",
    product: "Future Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Serap Yürek",
    title: "Çok rahat",
    comment: "Çok rahat herkese tavsiye ederim.",
    product: "Future Air Clean",
    star: 5,
    image: false,
    video: "",
    poster: ""
},
{
    name: "Emren Nalbant",
    title: "Çok memnunum.",
    comment: "Çok memnunum. Çok rahat. İyi ki almışım.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "",
    poster: ""
},
{
    name: "Mustafa ÇAYIR",
    title: "Çok memnunum.",
    comment: "Memnunum.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "",
    poster: ""
},
{
    name: "Melisa İdikut",
    title: "Memnuniyet",
    comment: "Normalde bana göre sosyal medyadan riske girerek alınmayacak bir ürün olmasına rağmen gerek yatağın tüm katmanlarının ozon ile temizleniyor gerekse kullanılan yatak içi malzemeleri ve doğal latex sebepleriyle ürünü almaya karar verdim.Nisan ayından beri kullanıyoruz gayet memnunuz.Ayrıca her türlü sorun destek ve önerilerinizi son derece dikkate alıp hızlıca aksiyona geçen son derece güvenilir bir ekiple yönetiliyor olması da kafanızda olabilecek soru işaretlerini hemen ortadan kaldırma konusunda son derece başarılı.Teşekkürler",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "",
    poster: ""
},
{
    name: "Chjjk Fbjjkkkk",
    title: "SAĞLIKLI UYKUNUN TEK ADRESİ",
    comment: "merhabalar ,öncelikle size şunu anlatmalıyım .slohtbedding tanışmanız gereken ve gerçekten her deneyimi size yaşatabilecek bir firma .Almış olduğumuz code air clean yatak bize uyku ve rahatlığın tüm konforunu yaşattı. bü yüzden sizlere yazmak istedik .her gece temiz uyumak diye bir kavram var ,yatakta yatarken eşiniz veya siz hareket etseniz bile rahatsız olmuyorsunuz derin uykudan uynama yok kısaca ) biz çok mennunuz herkese bu deneyimi tavsiye ediyoruz.TEŞEKÜRLER",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "sibel BAYRAKTAR",
    title: "BİZDEN YANA TAM 100 PUAN",
    comment: "MERHABALAR , KENDİNİZE NE ARADIĞINIZI SORDUĞUNUZDA ,YATAK VE UYKUYLA İLGİLİ TÜM CEVAPLARI BULABİLECEK OLDUĞUNUZ VE BİZİ HİÇ KIRMADAN SABIRLA DİNLEYEN, EN UYGUN YATAK İÇİN ,DEFALARCA ARAYAN ,UYKU UZMANLRIYLA TÜM SORUNLARINIZA ÇARE BULABİLECEK OLDUNUZ YER SLOTH BEDDİNG.100 DE AZ KALIR KESİNLİKE DENENMELİ ......",
    product: "Code Air Clean",
    star: 5,
    image: true,
    video: "",
    poster: ""
},
{
    name: "Çağrı Bursalıoğlu",
    title: "Çok güzel ve kaliteli bir yatak",
    comment: "Çok güzel ve kaliteli bir yatak. Ne çok sert ne çok yumuşak. İlgili personeller de gayet kibar ve nazikler.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "",
    poster: ""
},
{
    name: "Orkun Gençoğlu",
    title: "Çok rahat, bir yatak",
    comment: "Çok rahat, bir yatak",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "",
    poster: ""
},
{
    name: "Oğuzhan Kanyış",
    title: "Memnuniyet",
    comment: "Boyutu ve yumuşaklığı çok ideal. Hem yumuşak hem de çocuk yatarken gömülmüyor. Memnunuz.",
    product: "Slothy Bamboo Bebe Yastık",
    star: 5,
    image: false,
    video: "",
    poster: ""
},
{
    name: "Ayşe Büyükcam",
    title: "Memnuniyet",
    comment: "Yatağın dokusu ve sertlik derecesi oldukça iyi. Dokunduğunuzda yeterince yumuşak ve yattığınızda omurganız için yeterince sert. Daha erken almadığımıza pişman olduk.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "",
    poster: ""
},
{
    name: "Gizem Küçük",
    title: "Çok güzel",
    comment: "İlgili bir satış ekibi ve tüm sorulara anında dönen bir takım var yaptığım alışverişten be aldığım hizmetten çok memnun oldum",
    product: "Future Air Clean",
    star: 5,
    image: false,
    video: "",
    poster: ""
},
{
    name: "Gülsüm Özdemir",
    title: "henüz bilemedim",
    comment: "sanırım alırken beklentimi biraz fazla yükseltmişim. sevdim yatağı negatif bir yorum yapmak ayıp olur ama beklediğim gibi mükemmel uyku puanlarına eriştirmedi. yatağa alışmayı bekliyorum. eşimin horlamasını azaltacağını bile ummuştum ancak horlamasının azalması bir yana öyle derin uyumaya başladı ki horladığında dürtsem bile uyanmıyor artık :D belki de uyku puanımı dolaylı yoldan azalttı bu bedding. bir ay sonra daha gerçekçi bir değerlendirme yapabilirim sanırım. (dipnot: henüz yastıklarımız ve temizleme için kullanılan makina ulaşmadı. 15 gün içinde kargolanır demişti telefondaki arkadaş.) iyi çalışmalar dilerim.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "",
    poster: ""
},
{
    name: "Meltem Ordu",
    title: "Çok konforlu",
    comment: "Yatağımı da buradan almıştım. Yastığı da buradan tercih ettim. 3 yaşında çocuğum için oldukça konforlu ve çok memnunuuz",
    product: "Slothy Visco Kids Yastık",
    star: 5,
    image: false,
    video: "",
    poster: ""
},
{
    name: "Özlem",
    title: "İnanılmaz",
    comment: "Özellikle yorum yazmak için geldim. Arkadaşlar bu yatak beni iyileştiriyor. Sırt ve bel ağrılarım giderek azalıyor. Bu nasıl olur ben de şaşkınım ve çok mutluyum. 🙂",
    product: "Logic Air Clean",
    star: 5,
    image: false,
    video: "",
    poster: ""
},
{
    name: "Yunus İnan",
    title: "Muhteşem",
    comment: "Yatağın iki tarafı isteğimize göre farklı sertlikte üretildi. Çok memnunuz.",
    product: "Code Air Clean",
    star: 5,
    image: false,
    video: "",
    poster: ""
}
    ]
